import React, { useState, useEffect, useCallback } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import {
  FaEdit,
  FaFileMedicalAlt,
  FaSave,
  FaSyncAlt,
  FaEye,
} from "react-icons/fa";
import "react-quill/dist/quill.snow.css";
import Cookies from "js-cookie";
import api from "../../config/configApi";
import { Stethoscope, FolderOpen, NotebookPen, ChevronRight } from "lucide-react";
import Swal from "sweetalert2";
import ReactQuill from "react-quill";
import { toast, ToastContainer } from "react-toastify";
import Menu from "../../components/MenuProntuario";
import Footer from "../../components/FooterPagina";
import { MousePointerClick } from "lucide-react";
import GuiaSPESADT from "../../components/GuiaSPESADT";
import Receituario from "../../components/ReceituarioANS";
import LaudoMedico from "../../components/LaudoMedico";
import AltaFisio from "../../components/AltaFisio";
import Atestado from "../../components/AtestadoMedico";
import ReceituarioEspecial from "../../components/ReceituarioANSEspecial";
import ReceituarioOftalmo from "../../components/ReceituarioOftalmo";
import { FileText } from "lucide-react";
import { jsPDF } from "jspdf";
import autoTable from "jspdf-autotable";
import Logo from "../../images/logopdf.png";
import WatermarkLogo from "../../assets/afrafep.png";
import odPng from "../../images/Direito.png";
import oePng from "../../images/Esquerdo.png";
import rodape from "../../images/rodape.png";
import GuiaSADTSalvas from "../../components/GuiaSPESADTSalvas";
import ProntuarioAnexos from "../../components/ProntuarioAnexos";
import GroupedProfessionalsAccordion from "../../components/GroupedProfessionalsAccordion";
import { agruparPorEspecialidade } from "../../utils/agrupamentoProntuarios";
import { buscarEspecialidadesProfissionais } from "../../utils/profissionaisEspecialidade";

interface ReceituarioLaudo {
  id: number;
  tipo: string;
  dtConsulta: string;
  hrConsulta: string;
  cid: string;
  atestadoQtdDias: number;
  prescricao: string;
  criadoEm: string;
  editadoEm: string;

  // ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¯ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¿ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â½Y"ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¯ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¿ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â½ Campos de Longe (OD/OE)
  odEsfLong: number | null;
  odCilLong: number | null;
  odEixoLong: number | null;
  odPrismaLong: number | null;
  odBaseLong: number | null;

  oeEsfLong: number | null;
  oeCilLong: number | null;
  oeEixoLong: number | null;
  oePrismaLong: number | null;
  oeBaseLong: number | null;

  // ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¯ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¿ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â½Y"ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¯ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¿ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â½ Campos de Perto (OD/OE)
  odEsfPerto: number | null;
  odCilPerto: number | null;
  odEixoPerto: number | null;
  odPrismaPerto: number | null;
  odBasePerto: number | null;

  oeEsfPerto: number | null;
  oeCilPerto: number | null;
  oeEixoPerto: number | null;
  oePrismaPerto: number | null;
  oeBasePerto: number | null;

  profissional: {
    idProfissional: number;
    nmProfissional: string;
    CRM?: string;
    especialidade: {
      idEspecialidade?: number;
      dsEspecialidade: string;
      exibeQuestEpidem?: string;
      realizaProced?: string;
    };
  };

  paciente: {
    cdPaciente: number;
    nrCarteiraPlano: string;
    nmPaciente: string;
    dtNascimento: string;
    flSexo: string;
    cdStatus: number;
    nuCpf: string;
    nmEndereco: string;
    nuEndereco: number;
    nmComplEndereco: string;
    nmBairroEndereco: string;
    nmCidadeEndereco: string;
    nmUfEndereco: string;
    cdCepEndereco: string;
  };
}

interface Evolucao {
  idEvolucao: number;
  cdPaciente: number;
  nuCpf: string;
  dtHraEvolucao: string;
  tipo: string;
  idProfissional: number;
  dsEvolucao: string;
  profissional: {
    idProfissional: number;
    nmProfissional: string;
    especialidade: {
      idEspecialidade: number;
      dsEspecialidade: string;
    };
  };
  dtHraAlteracao: string;
  cdMedicoAlteracao: number | null;
  localEvolucao: string;
  maisSaude: string | null;
}

interface Profissional {
  id: number;
  nome: string;
  CRM?: string;
}

interface Especialidade {
  idEspecialidade: number;
  dsEspecialidade: string;
}

interface Paciente {
  cdPaciente: number;
  nmPaciente: string;
  flSexo: string;
}

interface Ciclo {
  id: number;
  paciente: Paciente;
  especialidade: Especialidade;
  dtInicio: string;
  dtFim: string;
  status: string;
  dtCadastro: string;
  dtAlteracao: string | null;
}

interface ReceituarioGrupo {
  especialidade: string;
  profissionais: {
    idProfissional: number;
    nome: string;
    items: ReceituarioLaudo[];
  }[];
}

interface EspecialidadeComPermissoes {
  idEspecialidade: number;
  dsEspecialidade: string;
  ativo: boolean;
  ativaAgendaOnlineSn: string;
  atendeMenorIdade: string;
  exibeQuestEpidem: string;
  realizaProced: string;
  cboTuss: string;
  guiaSadt: boolean;
  receituarioComum: boolean;
  receituarioEspecial: boolean;
  atestado: boolean;
  laudo: boolean;
  oftalmo: boolean | null;
  altaFisio: boolean | null;
}

const AtendimentoCompleto = () => {
  const navigate = useNavigate();

  const NuCPF = Cookies.get("NuCPF");
  const cdPaciente2 = Cookies.get("cdPaciente");
  const nome2 = Cookies.get("Nome");
  const idade = Cookies.get("idade");
  const flPms = Cookies.get("flPms");

  const [especialidadeAtual, setEspecialidadeAtual] =
    useState<EspecialidadeComPermissoes | null>(null);

  useEffect(() => {
    const fetchEspecialidadeAtual = async () => {
      try {
        const token = sessionStorage.getItem("token");
        const idEspecialidade = Cookies.get("idEspecialidade");

        if (token && idEspecialidade) {
          const response = await api.get(
            `/sisclinic/especialidades/${idEspecialidade}`,
            {
              headers: { Authorization: `Bearer ${token}` },
            },
          );
          setEspecialidadeAtual(response.data);
        }
      } catch (error) {
        console.error("Erro ao buscar dados da especialidade:", error);
      }
    };

    fetchEspecialidadeAtual();
  }, []);

  const RenderDocumentos = () => {
    if (!especialidadeAtual) return null;

    return (
      <>
        {especialidadeAtual?.guiaSadt && <GuiaSPESADT />}
        {especialidadeAtual?.receituarioComum && <Receituario />}
        {especialidadeAtual?.receituarioEspecial && <ReceituarioEspecial />}
        {especialidadeAtual?.oftalmo && <ReceituarioOftalmo />}
        {especialidadeAtual?.atestado && <Atestado />}
        {especialidadeAtual?.altaFisio && <AltaFisio />}
        {especialidadeAtual?.laudo && <LaudoMedico />}
      </>
    );
  };

  const [receituariosLaudos, setReceituariosLaudos] = useState<
    ReceituarioLaudo[]
  >([]);

  const [loadingReceituarios, setLoadingReceituarios] = useState(true);

  const [meusAtendimentos, setMeusAtendimentos] = useState<Evolucao[]>([]);
  const [outrosProfissionais, setOutrosProfissionais] = useState<Evolucao[]>(
    [],
  );
  const [, setProfissionais] = useState<Profissional[]>([]);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const [isOpen, setIsOpen] = useState(false);
  const [ciclos, setCiclos] = useState<Ciclo[]>([]);

  const [loadingMeus, setLoadingMeus] = useState(true);
  const [loadingOutros, setLoadingOutros] = useState(true);
  const [prontuarioAtual, setProntuarioAtual] = useState<string>("");
  const [prontuarioAtualId, setProntuarioAtualId] = useState<number | null>(
    null,
  );
  const [prontuarioAnexosId, setProntuarioAnexosId] = useState<number | null>(
    null,
  );
  const [anexosRefreshKey, setAnexosRefreshKey] = useState(0);
  const [salvando, setSalvando] = useState<boolean>(false);
  const [modoEdicao, setModoEdicao] = useState(true);

  const CRM = Cookies.get("CRM");

  const [currentPage, setCurrentPage] = useState<number>(1);
  const itemsPerPage = 4;

  const location = useLocation();
  const [, setDados] = useState(null);
  const { idEvent, nome, cdPaciente, idProfissional } = location.state || {};
  const [evolucaoEditando, setEvolucaoEditando] = useState<Evolucao | null>(
    null,
  );
  const [modalAberto, setModalAberto] = useState(false);
  const [modalAberto2, setModalAberto2] = useState(false);

  const [, setShowButtons] = useState(true);
  const [activeTab, setActiveTab] = useState<
    "meus" | "outros" | "sadt" | "receituarios" | "altas" | null
  >("meus");
  const [outrosCurrentPages, setOutrosCurrentPages] = useState<
    Record<string, number>
  >({});
  const outrosItensPorPagina = 10;

  const [expandedEspecialidades, setExpandedEspecialidades] = useState<
    string[]
  >([]);

  const [especialidades, setEspecialidades] = useState<any[]>([]);
  const [dtInicio, setDtInicio] = useState("");
  const [dtFim, setDtFim] = useState("");
  const [status, setStatus] = useState("");
  const [idEspecialidade, setIdEspecialidade] = useState<number | string>("");

  const [prontuarioIndexAberto, setProntuarioIndexAberto] = useState<
    number | null
  >(null);

  const [paginaAtual, setPaginaAtual] = useState(1);
  const itensPorPagina = 7;

  const totalPaginas = Math.ceil(meusAtendimentos.length / itensPorPagina);

  const mudarPagina = (novaPagina: number) => {
    if (novaPagina >= 1 && novaPagina <= totalPaginas) {
      setPaginaAtual(novaPagina);
      setProntuarioIndexAberto(null);
    }
  };

  const sortedCiclos = [...ciclos].sort((a, b) => {
    const dateA = new Date(a.dtCadastro);
    const dateB = new Date(b.dtCadastro);
    return dateB.getTime() - dateA.getTime();
  });

  const paginatedCiclos = sortedCiclos.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage,
  );

  const [expandedProfissionais, setExpandedProfissionais] = useState<number[]>(
    [],
  );

  const [grupos, setGrupos] = useState<ReceituarioGrupo[]>([]);
  const [loadingGrupos, setLoadingGrupos] = useState(true);
  const [gruposAltas, setGruposAltas] = useState<ReceituarioGrupo[]>([]);
  const [loadingGruposAltas, setLoadingGruposAltas] = useState(true);

  const fetchReceituariosLaudos = useCallback(async () => {
    const cpf = Cookies.get("NuCPF");
    const token = sessionStorage.getItem("token");

    if (cpf && token) {
      try {
        setLoadingReceituarios(true);
        const response = await api.get<ReceituarioLaudo[]>(
          `/sisclinic/receituarios/cpf/${cpf}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          },
        );

        const receituariosOrdenados = response.data.sort((a, b) => {
          const dateA = new Date(`${a.dtConsulta}T${a.hrConsulta}`);
          const dateB = new Date(`${b.dtConsulta}T${b.hrConsulta}`);
          return dateB.getTime() - dateA.getTime();
        });

        setReceituariosLaudos(receituariosOrdenados);
      } catch (error) {
        console.error("Erro ao buscar Receituarios e laudos:", error);
      } finally {
        setLoadingReceituarios(false);
      }
    }
  }, []);

  const toggleEspecialidade = (especialidade: string) => {
    setExpandedEspecialidades((prev) =>
      prev.includes(especialidade)
        ? prev.filter((e) => e !== especialidade)
        : [especialidade],
    );
  };

  const toggleProfissional = (
    idProfissional: number,
    _especialidade?: string,
  ) => {
    setExpandedProfissionais((prev) =>
      prev.includes(idProfissional)
        ? prev.filter((id) => id !== idProfissional)
        : [idProfissional],
    );
  };

  useEffect(() => {
    const loadGrupos = async () => {
      if (receituariosLaudos.length === 0) {
        setGrupos([]);
        setGruposAltas([]);
        setLoadingGrupos(false);
        setLoadingGruposAltas(false);
        return;
      }

      const token = sessionStorage.getItem("token");
      const [gruposData, gruposAltasData] = await Promise.all([
        agruparPorEspecialidade(
          receituariosLaudos,
          (item) => item.tipo !== "ALTA_FISIO",
          token,
        ),
        agruparPorEspecialidade(
          receituariosLaudos,
          (item) => item.tipo === "ALTA_FISIO",
          token,
        ),
      ]);

      setGrupos(gruposData);
      setGruposAltas(gruposAltasData);
      setLoadingGrupos(false);
      setLoadingGruposAltas(false);
    };

    setLoadingGrupos(true);
    setLoadingGruposAltas(true);
    loadGrupos();
  }, [receituariosLaudos]);

  useEffect(() => {
    fetchReceituariosLaudos();
  }, [fetchReceituariosLaudos]);
  const diasPorExtenso = (dias: number) => {
    const unidades = [
      "zero",
      "um",
      "dois",
      "trÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Âªs",
      "quatro",
      "cinco",
      "seis",
      "sete",
      "oito",
      "nove",
    ];
    const dezes = [
      "dez",
      "onze",
      "doze",
      "treze",
      "quatorze",
      "quinze",
      "dezesseis",
      "dezessete",
      "dezoito",
      "dezenove",
    ];
    const dezenas = [
      "vinte",
      "trinta",
      "quarenta",
      "cinquenta",
      "sessenta",
      "setenta",
      "oitenta",
      "noventa",
    ];

    if (dias < 10) return unidades[dias];
    if (dias < 20) return dezes[dias - 10];
    if (dias < 100) {
      const dezena = Math.floor(dias / 10);
      const resto = dias % 10;
      return dezenas[dezena - 2] + (resto !== 0 ? ` e ${unidades[resto]}` : "");
    }
    return dias.toString();
  };

  const handleGenerateAtestadoPDF = async (item: ReceituarioLaudo) => {
    const doc = new jsPDF({
      orientation: "portrait",
      unit: "pt",
      format: "a4",
    });

    const marginLeft = 40;
    const marginRight = 40;
    const marginTop = 0;
    const pageWidth =
      doc.internal.pageSize.getWidth() - marginLeft - marginRight;
    const centerX = doc.internal.pageSize.getWidth() / 2;

    const logoImg = new Image();
    logoImg.src = Logo;

    await new Promise((resolve) => {
      logoImg.onload = () => {
        const logoWidth = 600;
        const logoHeight = (logoImg.height * logoWidth) / logoImg.width;
        doc.addImage(
          logoImg,
          "PNG",
          centerX - logoWidth / 2,
          marginTop,
          logoWidth,
          logoHeight,
        );
        resolve(null);
      };
    });

    const headerY = marginTop + 150;
    doc.setFontSize(12);
    doc.setTextColor(36, 99, 235);
    doc.text(
      "AssociaÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â§ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â£o dos Auditores Fiscais do Estado da ParaÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â­ba",
      centerX,
      headerY,
      { align: "center" },
    );

    doc.setFontSize(18);
    doc.setTextColor(36, 99, 235);
    doc.setFont("helvetica", "bold");
    doc.text("ATESTADO MÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¯ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¿ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â½?DICO", centerX, headerY + 30, { align: "center" });

    const contentY = headerY + 80;
    doc.setFontSize(12);
    doc.setTextColor(0, 0, 0);
    doc.setFont("helvetica", "normal");

    let yPosition = contentY;
    const firstParagraph = `Atesto, para os devidos fins, a pedido do interessado, que o Sr.(a) ${
      item.paciente.nmPaciente
    }, portador do CPF: ${
      item.paciente.nuCpf
    } foi submetido ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â  consulta nesta data, no horÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¡rio das ${
      item.hrConsulta || "nÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â£o informado"
    }, sendo portador de afecÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â§ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â£o CID-${item.cid || "nÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â£o informado"}.`;
    const splitFirstParagraph = doc.splitTextToSize(firstParagraph, pageWidth);
    doc.text(splitFirstParagraph, marginLeft, yPosition);
    yPosition += splitFirstParagraph.length * 20;

    const diasAfastamento = item.atestadoQtdDias || 0;
    const diasEscritoAfastamento = diasPorExtenso(diasAfastamento);
    const dataAtestado =
      formatDate(item.dtConsulta) || new Date().toLocaleDateString("pt-BR");

    const secondParagraph = `Em decorrÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Âªncia deverÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¡ permanecer afastado de suas atividades laborativas por um perÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â­odo de ${diasAfastamento} (${diasEscritoAfastamento}) dia(s) a partir desta data. JoÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â£o Pessoa, ${dataAtestado}.`;
    const splitSecondParagraph = doc.splitTextToSize(
      secondParagraph,
      pageWidth,
    );
    doc.text(splitSecondParagraph, marginLeft, yPosition + 20);
    yPosition += splitSecondParagraph.length * 20 + 40;

    doc.text("_________________________________________", centerX, yPosition, {
      align: "center",
    });
    doc.setFont("helvetica", "bold");
    doc.text(
      `Dr. ${item.profissional.nmProfissional}`,
      centerX,
      yPosition + 20,
      {
        align: "center",
      },
    );

    yPosition += 140;
    doc.setFont("helvetica", "bold");
    doc.setFontSize(14);
    doc.text("AutorizaÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â§ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â£o", centerX, yPosition, { align: "center" });
    doc.setFontSize(12);
    doc.setFont("helvetica", "normal");

    const authorizationText = `Eu, ${
      item.paciente.nmPaciente
    }, autorizo o Dr. ${
      item.profissional.nmProfissional
    } a registrar o diagnÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â³stico (codificado - CID: ${
      item.cid || "nÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â£o informado"
    } ou por extenso) neste atestado.`;
    const splitAuthorization = doc.splitTextToSize(
      authorizationText,
      pageWidth,
    );
    doc.text(splitAuthorization, marginLeft, yPosition + 30);

    yPosition += splitAuthorization.length * 20 + 60;
    doc.text("_________________________________________", centerX, yPosition, {
      align: "center",
    });
    doc.text("Assinatura do UsuÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¡rio - RG", centerX, yPosition + 20, {
      align: "center",
    });

    const watermarkImg = new Image();
    watermarkImg.src = WatermarkLogo;

    await new Promise((resolve) => {
      watermarkImg.onload = () => {
        const watermarkWidth = 300;
        const watermarkHeight =
          (watermarkImg.height * watermarkWidth) / watermarkImg.width;
        const centerX = doc.internal.pageSize.getWidth() / 2;
        const centerY = doc.internal.pageSize.getHeight() / 2;

        const canvas = document.createElement("canvas");
        canvas.width = watermarkImg.width;
        canvas.height = watermarkImg.height;
        const ctx = canvas.getContext("2d");
        if (!ctx) return;

        ctx.drawImage(watermarkImg, 0, 0, canvas.width, canvas.height);
        const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
        const data = imageData.data;

        for (let i = 0; i < data.length; i += 4) {
          if (data[i] > 150 && data[i + 1] < 80 && data[i + 2] < 80) {
            data[i] = 36;
            data[i + 1] = 99;
            data[i + 2] = 235;
            data[i + 3] = 51;
          }
        }

        ctx.putImageData(imageData, 0, 0);
        doc.addImage(
          canvas,
          "PNG",
          centerX - watermarkWidth / 2,
          centerY - watermarkHeight / 2,
          watermarkWidth,
          watermarkHeight,
        );
        resolve(null);
      };
    });

    const footerY = doc.internal.pageSize.getHeight() - 80;
    doc.setFontSize(8);
    doc.setTextColor(36, 99, 235);

    const leftColX = marginLeft;
    doc.text(
      "Rua CorÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¡lio Soares de Oliveira, 497 ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¯ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¿ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â½?ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¯ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¿ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â½ Centro, JoÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â£o Pessoa ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¯ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¿ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â½?ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¯ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¿ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â½ PB",
      leftColX,
      footerY,
    );
    doc.text("Fone: (83) 3533.5310 | 3533.5311", leftColX, footerY + 15);
    doc.text("www.afrafep.org.br", leftColX, footerY + 30);
    doc.text("INSC. ANS NÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â° 330281", leftColX, footerY + 45);

    const rightColX = doc.internal.pageSize.getWidth() - marginRight - 200;
    doc.text("ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¯ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¿ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â½?tica e TransparÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Âªncia", rightColX, footerY);
    doc.text(
      "Solidariedade e Responsabilidade Social",
      rightColX,
      footerY + 15,
    );
    doc.text("Comprometimento e Profissionalismo", rightColX, footerY + 30);
    doc.text("Legalidade e Respeito", rightColX, footerY + 45);

    const pdfBlob = doc.output("blob");
    const pdfUrl = URL.createObjectURL(pdfBlob);

    const iframe = document.createElement("iframe");
    iframe.style.display = "none";
    iframe.src = pdfUrl;
    document.body.appendChild(iframe);

    iframe.onload = function () {
      setTimeout(function () {
        iframe.contentWindow?.print();
      }, 500);
    };

    return pdfBlob;
  };

  const htmlToFormattedText = (html: string): string => {
    const tempDiv = document.createElement("div");
    tempDiv.innerHTML = html;

    const processNode = (node: Node): string => {
      if (node.nodeType === Node.TEXT_NODE) {
        return node.textContent?.replace(/\s+/g, " ") || "";
      } else if (node.nodeType === Node.ELEMENT_NODE) {
        const element = node as HTMLElement;

        switch (element.tagName.toLowerCase()) {
          case "p":
            return (
              Array.from(element.childNodes).map(processNode).join("") + "\n"
            );
          case "br":
            return "\n";
          case "div":
            return (
              Array.from(element.childNodes).map(processNode).join("") + "\n"
            );
          case "strong":
          case "b":
            return Array.from(element.childNodes).map(processNode).join("");
          case "em":
          case "i":
            return Array.from(element.childNodes).map(processNode).join("");
          case "ul":
            return Array.from(element.children)
              .map((li) => "ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¯ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¿ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â½?ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¯ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¿ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â½ " + processNode(li) + "\n")
              .join("");
          case "ol":
            return Array.from(element.children)
              .map((li, index) => index + 1 + ". " + processNode(li) + "\n")
              .join("");
          case "li":
            return Array.from(element.childNodes)
              .map(processNode)
              .join("")
              .trim();
          default:
            return Array.from(element.childNodes).map(processNode).join("");
        }
      }
      return "";
    };

    let result = Array.from(tempDiv.childNodes).map(processNode).join("");

    result = result
      .replace(/\n\s*\n/g, "\n")
      .replace(/\n{3,}/g, "\n\n")
      .replace(/[ \t]+/g, " ")
      .trim();

    return result;
  };

  const handleGenerateAltaFisioPDF = async (item: ReceituarioLaudo) => {
    const doc = new jsPDF({
      orientation: "portrait",
      unit: "pt",
      format: "a4",
    });

    const marginLeft = 40;
    const marginRight = 40;
    const marginTop = 0;
    const pageWidth =
      doc.internal.pageSize.getWidth() - marginLeft - marginRight;
    const centerX = doc.internal.pageSize.getWidth() / 2;

    const crm = Cookies.get("CRM");

    const logoImg = new Image();
    logoImg.src = Logo;

    await new Promise((resolve) => {
      logoImg.onload = () => {
        const logoWidth = 600;
        const logoHeight = (logoImg.height * logoWidth) / logoImg.width;
        doc.addImage(
          logoImg,
          "PNG",
          centerX - logoWidth / 2,
          marginTop,
          logoWidth,
          logoHeight,
        );
        resolve(null);
      };
    });

    const headerY = marginTop + 150;
    doc.setFontSize(15);
    doc.setTextColor(36, 99, 235);
    doc.text(
      "AssociaÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â§ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â£o dos Auditores Fiscais do Estado da ParaÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â­ba",
      centerX,
      headerY,
      { align: "center" },
    );

    doc.setFontSize(18);
    doc.setTextColor(36, 99, 235);
    doc.setFont("helvetica", "bold");
    doc.text("ALTA FISIOTERAPIA", centerX, headerY + 30, { align: "center" });

    const pacienteY = headerY + 60;
    doc.setFontSize(12);
    doc.setTextColor(0, 0, 0);
    doc.setFont("helvetica", "normal");
    doc.text(
      `Paciente: ${item.paciente?.nmPaciente || "NÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â£o informado"}`,
      marginLeft,
      pacienteY,
    );

    const contentY = pacienteY + 30;
    doc.setFont("helvetica", "bold");
    doc.text("PrescriÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â§ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â£o:", marginLeft, contentY);

    doc.setFont("helvetica", "normal");
    const contentText = htmlToFormattedText(item.prescricao);
    const splitText = doc.splitTextToSize(contentText, pageWidth);

    const lineHeight = 14;
    let currentY = contentY + 20;

    for (let i = 0; i < splitText.length; i++) {
      doc.text(splitText[i], marginLeft, currentY);
      currentY += lineHeight;
    }

    const watermarkImg = new Image();
    watermarkImg.src = WatermarkLogo;

    await new Promise((resolve) => {
      watermarkImg.onload = () => {
        const watermarkWidth = 300;
        const watermarkHeight =
          (watermarkImg.height * watermarkWidth) / watermarkImg.width;
        const centerX = doc.internal.pageSize.getWidth() / 2;
        const centerY = doc.internal.pageSize.getHeight() / 2;

        const canvas = document.createElement("canvas");
        canvas.width = watermarkImg.width;
        canvas.height = watermarkImg.height;
        const ctx = canvas.getContext("2d");
        if (!ctx) return;

        ctx.drawImage(watermarkImg, 0, 0, canvas.width, canvas.height);
        const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
        const data = imageData.data;

        for (let i = 0; i < data.length; i += 4) {
          if (data[i] > 150 && data[i + 1] < 80 && data[i + 2] < 80) {
            data[i] = 36;
            data[i + 1] = 99;
            data[i + 2] = 235;
            data[i + 3] = 51;
          }
        }

        ctx.putImageData(imageData, 0, 0);
        doc.addImage(
          canvas,
          "PNG",
          centerX - watermarkWidth / 2,
          centerY - watermarkHeight / 2,
          watermarkWidth,
          watermarkHeight,
        );
        resolve(null);
      };
    });

    const signatureY = doc.internal.pageSize.getHeight() - 180;

    doc.text("_________________________________________", centerX, signatureY, {
      align: "center",
    });

    doc.setFont("helvetica", "bold");
    doc.text(
      `Dr. ${item.profissional.nmProfissional}`,
      centerX,
      signatureY + 20,
      { align: "center" },
    );

    doc.setFont("helvetica", "normal");
    doc.setFontSize(12);
    doc.text(`CRM: ${crm ? crm : "NÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â£o informado"}`, centerX, signatureY + 40, {
      align: "center",
    });

    const dataAtual = new Date().toLocaleDateString("pt-BR", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
    });

    const pageTotalWidth = doc.internal.pageSize.getWidth();

    doc.text(
      `Data: ${dataAtual}`,
      pageTotalWidth - marginRight,
      signatureY + 60,
      {
        align: "right",
      },
    );

    const footerY = doc.internal.pageSize.getHeight() - 80;
    doc.setFontSize(9);

    const leftColX = marginLeft;
    doc.text(
      "Rua CorÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¡lio Soares de Oliveira, 497 ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¯ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¿ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â½?ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¯ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¿ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â½ Centro, JoÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â£o Pessoa ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¯ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¿ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â½?ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¯ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¿ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â½ PB",
      leftColX,
      footerY,
    );
    doc.text("Fone: (83) 3533.5310 | 3533.5311", leftColX, footerY + 15);
    doc.text("www.afrafep.org.br", leftColX, footerY + 30);
    doc.text("INSC. ANS NÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â° 330281", leftColX, footerY + 45);

    doc.setTextColor(0, 0, 255);
    const rightColX = marginLeft + pageWidth / 2 + 80;
    doc.text("ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¯ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¿ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â½?tica e TransparÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Âªncia", rightColX, footerY);
    doc.text(
      "Solidariedade e Responsabilidade Social",
      rightColX,
      footerY + 15,
    );
    doc.text("Comprometimento e Profissionalismo", rightColX, footerY + 30);
    doc.text("Legalidade e Respeito", rightColX, footerY + 45);

    const pdfBlob = doc.output("blob");
    const pdfUrl = URL.createObjectURL(pdfBlob);

    const iframe = document.createElement("iframe");
    iframe.style.display = "none";
    iframe.src = pdfUrl;
    document.body.appendChild(iframe);

    iframe.onload = function () {
      setTimeout(function () {
        iframe.contentWindow?.print();
      }, 500);
    };

    return pdfBlob;
  };

  const handleGenerateLaudoPDF = async (item: ReceituarioLaudo) => {
    const doc = new jsPDF({
      orientation: "portrait",
      unit: "pt",
      format: "a4",
    });

    const marginLeft = 40;
    const marginRight = 40;
    const marginTop = 20;
    const pageWidth =
      doc.internal.pageSize.getWidth() - marginLeft - marginRight;
    const pageHeight = doc.internal.pageSize.getHeight();
    const centerX = doc.internal.pageSize.getWidth() / 2;
    let currentY = marginTop;

    const addFooter = () => {
      const additionalInfo = [
        "Rua: Coralio Soares de Oliveira, nÃ‚Âº 497, Centro, Joao Pessoa - PB, CEP 58.013-260.",
        "Telefone: 3533-5310 - www.afrafepsaude.com.br  @afrafepsaude",
        "CNPJ: 09.306.242/0001-82.",
      ];

      doc.setTextColor(105, 105, 105);
      let yOffset = pageHeight - 80;

      additionalInfo.forEach((line) => {
        const splitText = doc.splitTextToSize(line, 300);
        splitText.forEach((textLine: any) => {
          doc.text(textLine, 25, yOffset);
          yOffset += 10;
        });
        yOffset += 5;
      });

      const imgWidth = 180;
      const imgHeight = 80;
      const xOffsetImage = doc.internal.pageSize.width - imgWidth - 40;
      const yOffsetImage = pageHeight - imgHeight - 17;
      doc.addImage(
        rodape,
        "PNG",
        xOffsetImage,
        yOffsetImage,
        imgWidth,
        imgHeight,
      );
    };

    const addHeader = async () => {
      const logoImg = new Image();
      logoImg.src = Logo;
      await new Promise<void>((resolve) => {
        logoImg.onload = () => {
          const imgWidth = doc.internal.pageSize.getWidth();
          const imgHeight = (logoImg.height * imgWidth) / logoImg.width;
          doc.addImage(Logo, "PNG", 0, 0, imgWidth, imgHeight);
          currentY = imgHeight + 30;
          resolve();
        };
        logoImg.onerror = (err) => {
          console.error("Erro ao carregar o logo:", err);
          resolve();
        };
      });
    };

    const addWatermark = async () => {
      await new Promise<void>((resolve) => {
        const watermarkImg = new Image();
        watermarkImg.src = WatermarkLogo;
        watermarkImg.onload = () => {
          const watermarkWidth = 350;
          const watermarkHeight =
            (watermarkImg.height * watermarkWidth) / watermarkImg.width;

          const canvas = document.createElement("canvas");
          canvas.width = watermarkImg.width;
          canvas.height = watermarkImg.height;
          const ctx = canvas.getContext("2d");

          if (ctx) {
            ctx.drawImage(watermarkImg, 0, 0);
            const imageData = ctx.getImageData(
              0,
              0,
              canvas.width,
              canvas.height,
            );
            const data = imageData.data;

            for (let i = 0; i < data.length; i += 4) {
              if (data[i] > 150 && data[i + 1] < 80 && data[i + 2] < 80) {
                data[i] = 36;
                data[i + 1] = 99;
                data[i + 2] = 235;
                data[i + 3] = 30;
              } else if (data[i + 3] > 0) {
                data[i + 3] = 30;
              }
            }
            ctx.putImageData(imageData, 0, 0);

            doc.addImage(
              canvas.toDataURL("image/png"),
              "PNG",
              centerX - watermarkWidth / 2,
              pageHeight / 2 - watermarkHeight / 2,
              watermarkWidth,
              watermarkHeight,
              undefined,
              "FAST",
            );
          }
          resolve();
        };
        watermarkImg.onerror = (err) => {
          console.error("Erro ao carregar a imagem da marca d'ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¡gua:", err);
          resolve();
        };
      });
    };

    const formatValue = (value: any) => value || "-";

    const addContent = async () => {
      await addWatermark();
      await addHeader();

      doc.setFontSize(12);
      doc.setFont("helvetica", "normal");
      doc.text(`Nome: ${item.paciente.nmPaciente}`, marginLeft, currentY);
      currentY += 20;

      const protractorWidth = 250;
      const protractorHeight = 150;
      const protractorX1 = marginLeft + 10;
      const protractorX2 = centerX + 10;
      const protractorY = currentY;

      doc.addImage(
        odPng,
        "PNG",
        protractorX1,
        protractorY,
        protractorWidth,
        protractorHeight,
      );
      doc.addImage(
        oePng,
        "PNG",
        protractorX2,
        protractorY,
        protractorWidth,
        protractorHeight,
      );

      currentY += protractorHeight + 30;

      const tablesData = [
        {
          title: "LONGE",
          data: {
            od: {
              esf: item.odEsfLong,
              cil: item.odCilLong,
              eixo: item.odEixoLong,
              prisma: item.odPrismaLong,
              base: item.odBaseLong,
            },
            oe: {
              esf: item.oeEsfLong,
              cil: item.oeCilLong,
              eixo: item.oeEixoLong,
              prisma: item.oePrismaLong,
              base: item.oeBaseLong,
            },
          },
        },
        {
          title: "PERTO",
          data: {
            od: {
              esf: item.odEsfPerto,
              cil: item.odCilPerto,
              eixo: item.odEixoPerto,
              prisma: item.odPrismaPerto,
              base: item.odBasePerto,
            },
            oe: {
              esf: item.oeEsfPerto,
              cil: item.oeCilPerto,
              eixo: item.oeEixoPerto,
              prisma: item.oePrismaPerto,
              base: item.oeBasePerto,
            },
          },
        },
      ];

      for (const table of tablesData) {
        const hasData =
          table.data.od.esf ||
          table.data.od.cil ||
          table.data.od.eixo ||
          table.data.od.prisma ||
          table.data.od.base ||
          table.data.oe.esf ||
          table.data.oe.cil ||
          table.data.oe.eixo ||
          table.data.oe.prisma ||
          table.data.oe.base;

        if (hasData) {
          doc.setFontSize(12);
          doc.setFont("helvetica", "bold");
          doc.text(table.title, marginLeft, currentY);
          currentY += 20;

          const bodyData = [
            [
              "OD",
              formatValue(table.data.od.esf),
              formatValue(table.data.od.cil),
              formatValue(table.data.od.eixo),
              formatValue(table.data.od.prisma),
              formatValue(table.data.od.base),
            ],
            [
              "OE",
              formatValue(table.data.oe.esf),
              formatValue(table.data.oe.cil),
              formatValue(table.data.oe.eixo),
              formatValue(table.data.oe.prisma),
              formatValue(table.data.oe.base),
            ],
          ];

          autoTable(doc, {
            head: [["Olho", "Esf.", "Cil.", "Eixo", "Prisma", "Base"]],
            body: bodyData,
            startY: currentY,
            theme: "grid",
            headStyles: {
              fillColor: [66, 139, 202],
              textColor: [255, 255, 255],
              fontStyle: "bold",
            },
            margin: { left: marginLeft, right: marginRight },
            styles: { fontSize: 10, halign: "center" },
            columnStyles: { 0: { cellWidth: "auto" } },
          });

          currentY = (doc as any).lastAutoTable.finalY + 20;
        }
      }

      if (item.prescricao) {
        if (currentY > pageHeight - 80) {
          doc.addPage();
          currentY = marginTop + 40;
        }
        doc.setFontSize(12);
        doc.setFont("helvetica", "bold");
        doc.text("OBS:", marginLeft, currentY);
        doc.setFont("helvetica", "normal");
        currentY += 15;
        const splitObs = doc.splitTextToSize(item.prescricao, pageWidth);
        doc.text(splitObs, marginLeft, currentY);
        currentY += splitObs.length * 15 + 20;
      }

      if (currentY > pageHeight - 100) {
        doc.addPage();
        currentY = marginTop + 40;
      }

      doc.setFontSize(10);

      const signatureLineWidth = 200;
      const signatureLineX = centerX - signatureLineWidth / 2;

      doc.line(
        signatureLineX,
        currentY + 60,
        signatureLineX + signatureLineWidth,
        currentY + 60,
      );

      doc.text("Carimbo e Assinatura do MÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â©dico", centerX, currentY + 75, {
        align: "center",
      });

      doc.text(`${item.profissional.nmProfissional}`, centerX, currentY + 90, {
        align: "center",
      });

      doc.text(
        `Data e hora de emissÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â£o: ${new Date().toLocaleString("pt-BR", {
          day: "2-digit",
          month: "2-digit",
          year: "numeric",
          hour: "2-digit",
          minute: "2-digit",
        })}`,
        doc.internal.pageSize.getWidth() - marginRight,
        currentY + 20,
        { align: "right" },
      );
      addFooter();
    };

    currentY = marginTop;
    await addContent();

    const totalPages = (doc as any).internal.getNumberOfPages();
    for (let i = 1; i <= totalPages; i++) {
      doc.setPage(i);
      doc.setFontSize(8);
      doc.setTextColor(100);
      doc.text(`Pagina ${i} de ${totalPages}`, centerX, pageHeight - 20, {
        align: "center",
      });
    }

    const pdfBlob = doc.output("blob");
    const pdfUrl = URL.createObjectURL(pdfBlob);

    const iframe = document.createElement("iframe");
    iframe.style.display = "none";
    iframe.src = pdfUrl;
    document.body.appendChild(iframe);

    iframe.onload = function () {
      setTimeout(function () {
        iframe.contentWindow?.print();
      }, 500);
    };

    return pdfBlob;
  };

  const handleGenerateReceituarioPDF = async (item: ReceituarioLaudo) => {
    const doc = new jsPDF({
      orientation: "portrait",
      unit: "pt",
      format: "a4",
    });

    const marginLeft = 40;
    const marginRight = 40;
    const marginTop = 0;
    const pageWidth =
      doc.internal.pageSize.getWidth() - marginLeft - marginRight;
    const centerX = doc.internal.pageSize.getWidth() / 2;
    const maxHeight = doc.internal.pageSize.getHeight();
    const bottomMargin = 180;

    const logoImg = new Image();
    logoImg.src = Logo;

    await new Promise((resolve) => {
      logoImg.onload = () => {
        const logoWidth = 600;
        const logoHeight = (logoImg.height * logoWidth) / logoImg.width;
        doc.addImage(
          logoImg,
          "PNG",
          centerX - logoWidth / 2,
          marginTop,
          logoWidth,
          logoHeight,
        );
        resolve(null);
      };
    });

    const headerY = marginTop + 150;
    doc.setFontSize(15);
    doc.setTextColor(36, 99, 235);
    doc.text(
      "AssociaÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â§ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â£o dos Auditores Fiscais do Estado da ParaÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â­ba",
      centerX,
      headerY,
      { align: "center" },
    );

    doc.setFontSize(18);
    doc.setTextColor(36, 99, 235);
    doc.setFont("helvetica", "bold");
    doc.text("RECEITUÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚ÂRIO COMUM", centerX, headerY + 30, { align: "center" });

    const patientY = headerY + 70;
    doc.setFont("helvetica", "bold");
    doc.setFontSize(12);
    doc.setTextColor(0, 0, 0);
    doc.text(
      `Paciente: ${item.paciente?.nmPaciente || "NÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â£o informado"}`,
      marginLeft,
      patientY,
    );

    const contentY = patientY + 30;
    doc.setFont("helvetica", "bold");
    doc.text("PrescriÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â§ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â£o:", marginLeft, contentY);

    doc.setFont("helvetica", "normal");
    doc.setFontSize(11);

    const contentText = item.prescricao
      .replace(/<br\s*\/?>/gi, "\n")
      .replace(/<\/p><p>/gi, "\n")
      .replace(/<[^>]*>/g, "")
      .replace(/&nbsp;/g, " ")
      .trim();

    const splitText = doc.splitTextToSize(contentText, pageWidth - 20);

    const lineHeight = 14;
    let currentY = contentY + 20;

    for (let i = 0; i < splitText.length; i++) {
      if (currentY + lineHeight > maxHeight - bottomMargin) {
        doc.addPage();
        currentY = marginTop + 40;

        doc.setFont("helvetica", "bold");
        doc.setFontSize(11);
        doc.text("PrescriÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â§ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â£o (continuaÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â§ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â£o):", marginLeft, currentY);
        currentY += 20;
        doc.setFont("helvetica", "normal");
      }

      doc.text(splitText[i], marginLeft + 10, currentY);
      currentY += lineHeight;
    }

    const watermarkImg = new Image();
    watermarkImg.src = WatermarkLogo;

    await new Promise((resolve) => {
      watermarkImg.onload = () => {
        const watermarkWidth = 300;
        const watermarkHeight =
          (watermarkImg.height * watermarkWidth) / watermarkImg.width;
        const centerY = doc.internal.pageSize.getHeight() / 2;

        const canvas = document.createElement("canvas");
        canvas.width = watermarkImg.width;
        canvas.height = watermarkImg.height;
        const ctx = canvas.getContext("2d");
        if (!ctx) return;

        ctx.drawImage(watermarkImg, 0, 0, canvas.width, canvas.height);
        const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
        const data = imageData.data;

        for (let i = 0; i < data.length; i += 4) {
          if (data[i] > 150 && data[i + 1] < 80 && data[i + 2] < 80) {
            data[i] = 36;
            data[i + 1] = 99;
            data[i + 2] = 235;
            data[i + 3] = 51;
          }
        }

        ctx.putImageData(imageData, 0, 0);

        const currentPage = doc.getCurrentPageInfo().pageNumber;
        doc.setPage(1);
        doc.addImage(
          canvas,
          "PNG",
          centerX - watermarkWidth / 2,
          centerY - watermarkHeight / 2,
          watermarkWidth,
          watermarkHeight,
          undefined,
          "FAST",
        );

        doc.setPage(currentPage);
        resolve(null);
      };
    });

    const signatureY = maxHeight - 210;
    doc.text("_________________________________________", centerX, signatureY, {
      align: "center",
    });

    doc.setFont("helvetica", "bold");
    doc.text(
      `Dr. ${item.profissional.nmProfissional}`,
      centerX,
      signatureY + 20,
      { align: "center" },
    );

    doc.setFont("helvetica", "normal");
    doc.setFontSize(12);
    doc.text(`CRM: ${CRM ? CRM : "NÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â£o informado"}`, centerX, signatureY + 40, {
      align: "center",
    });

    const totalPages = doc.getNumberOfPages();
    for (let i = 1; i <= totalPages; i++) {
      doc.setPage(i);

      const footerY = maxHeight - 80;
      doc.setFontSize(9);

      doc.setTextColor(0, 0, 0);
      const leftColX = marginLeft;
      doc.text(
        "Rua CorÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¡lio Soares de Oliveira, 497 ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¯ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¿ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â½?ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¯ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¿ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â½ Centro, JoÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â£o Pessoa ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¯ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¿ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â½?ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¯ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¿ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â½ PB",
        leftColX,
        footerY,
      );
      doc.text("Fone: (83) 3533.5310 | 3533.5311", leftColX, footerY + 15);
      doc.text("www.afrafep.org.br", leftColX, footerY + 30);
      doc.text("INSC. ANS NÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â° 330281", leftColX, footerY + 45);

      doc.setTextColor(0, 0, 255);
      const rightColX = marginLeft + pageWidth / 2 + 80;
      doc.text("ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¯ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¿ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â½?tica e TransparÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Âªncia", rightColX, footerY);
      doc.text(
        "Solidariedade e Responsabilidade Social",
        rightColX,
        footerY + 15,
      );
      doc.text("Comprometimento e Profissionalismo", rightColX, footerY + 30);
      doc.text("Legalidade e Respeito", rightColX, footerY + 45);
    }

    const pdfBlob = doc.output("blob");
    const pdfUrl = URL.createObjectURL(pdfBlob);

    const iframe = document.createElement("iframe");
    iframe.style.display = "none";
    iframe.src = pdfUrl;
    document.body.appendChild(iframe);

    iframe.onload = function () {
      setTimeout(function () {
        iframe.contentWindow?.print();
      }, 500);
    };

    return pdfBlob;
  };

  const handleGenerateReceituarioEspecialPDF = async (
    item: ReceituarioLaudo,
  ) => {
    const doc = new jsPDF({
      orientation: "landscape",
      unit: "pt",
      format: "a4",
    });

    const crm = Cookies.get("CRM") || "NÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â£o informado";

    const pageWidth = doc.internal.pageSize.getWidth();
    const pageHeight = doc.internal.pageSize.getHeight();
    const halfWidth = pageWidth / 2;
    const margin = 40;
    const footerHeight = 120;

    const addWatermark = async (x: number, y: number, width: number) => {
      const watermarkImg = new Image();
      watermarkImg.src = WatermarkLogo;

      return new Promise((resolve) => {
        watermarkImg.onload = () => {
          const watermarkHeight =
            (watermarkImg.height * width) / watermarkImg.width;

          const canvas = document.createElement("canvas");
          canvas.width = watermarkImg.width;
          canvas.height = watermarkImg.height;
          const ctx = canvas.getContext("2d");
          if (!ctx) return;

          ctx.drawImage(watermarkImg, 0, 0, canvas.width, canvas.height);
          const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
          const data = imageData.data;

          for (let i = 0; i < data.length; i += 4) {
            if (data[i] > 150 && data[i + 1] < 80 && data[i + 2] < 80) {
              data[i] = 36;
              data[i + 1] = 99;
              data[i + 2] = 235;
              data[i + 3] = 30;
            }
          }

          ctx.putImageData(imageData, 0, 0);

          doc.addImage(
            canvas,
            "PNG",
            x + (halfWidth - width) / 2,
            y + (pageHeight - watermarkHeight) / 2,
            width,
            watermarkHeight,
            undefined,
            "FAST",
          );
          resolve(null);
        };
      });
    };

    const addHeader = async (x: number, y: number): Promise<number> => {
      const logoImg = new Image();
      logoImg.src = Logo;

      return new Promise((resolve) => {
        logoImg.onload = () => {
          const logoWidth = halfWidth - margin * 2;
          const logoHeight = (logoImg.height * logoWidth) / logoImg.width;

          doc.addImage(logoImg, "PNG", x + margin, y, logoWidth, logoHeight);

          doc.setFontSize(9);
          doc.setTextColor(0, 0, 0);
          doc.text(
            "1ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Âª Via - RetenÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â§ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â£o da FarmÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¡cia ou Drogaria",
            x + halfWidth - margin,
            y + logoHeight + 12,
            { align: "right" },
          );
          doc.text(
            "2ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Âª Via - OrientaÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â§ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â£o ao Paciente",
            x + halfWidth - margin,
            y + logoHeight + 24,
            { align: "right" },
          );

          resolve(logoHeight);
        };
      });
    };

    const addFooter = (x: number, y: number) => {
      doc.setFontSize(6);
      doc.setTextColor(100, 100, 100);

      const leftColX = x + margin;
      const startY = y + 20;

      doc.text(
        "Rua CorÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¡lio Soares de Oliveira, 497 ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¯ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¿ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â½?ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¯ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¿ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â½ Centro, JoÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â£o Pessoa ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¯ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¿ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â½?ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¯ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¿ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â½ PB",
        leftColX,
        startY,
      );
      doc.text("Fone: (83) 3533.5310 | 3533.5311", leftColX, startY + 10);
      doc.text("www.afrafep.org.br", leftColX, startY + 20);
      doc.text("INSC. ANS NÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â° 330281", leftColX, startY + 30);

      doc.setTextColor(0, 0, 200);
      const rightColX = x + halfWidth - margin - 120;
      doc.setFontSize(6);
      doc.text("ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¯ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¿ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â½?tica e TransparÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Âªncia", rightColX, startY);
      doc.text(
        "Solidariedade e Responsabilidade Social",
        rightColX,
        startY + 10,
      );
      doc.text("Comprometimento e Profissionalismo", rightColX, startY + 20);
      doc.text("Legalidade e Respeito", rightColX, startY + 30);
    };

    const drawContent = async (x: number, y: number) => {
      let currentY = y;

      await addWatermark(x, currentY, 180);

      const logoHeight = await addHeader(x, currentY);
      currentY += logoHeight + 40;

      doc.setFont("helvetica", "bold");
      doc.setFontSize(10);
      doc.text("RECEITUÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚ÂRIO CONTROLE ESPECIAL", x + halfWidth / 2, currentY, {
        align: "center",
      });
      currentY += 25;

      doc.setFontSize(10);
      doc.setFont("helvetica", "bold");
      doc.text("IDENTIFICAÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¯ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¿ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â½?ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¯ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¿ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â½fO DO EMITENTE", x + margin, currentY);

      doc.setFont("helvetica", "normal");
      doc.setFontSize(8);
      doc.text(
        `Nome completo: Dr. ${item.profissional.nmProfissional}`,
        x + margin,
        currentY + 18,
      );

      doc.text(`CRM: ${crm}`, x + margin, currentY + 32);

      doc.text("CNPJ: 09.306.242/0001-82", x + margin, currentY + 46);

      const enderecoEmitenteText = doc.splitTextToSize(
        "Endereco completo e Telefone: Rua Coralio Soares de Oliveira - 497, Centro (83) 3533.5310",
        halfWidth - margin * 2 - 15,
      );
      doc.text(enderecoEmitenteText, x + margin, currentY + 60);

      const enderecoEmitenteHeight = enderecoEmitenteText.length * 9;
      doc.text(
        "Cidade: JoÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â£o Pessoa",
        x + margin,
        currentY + 60 + enderecoEmitenteHeight + 8,
      );
      doc.text(
        "UF: ParaÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â­ba",
        x + margin,
        currentY + 60 + enderecoEmitenteHeight + 20,
      );

      currentY += 60 + enderecoEmitenteHeight + 35;

      doc.setDrawColor(200, 200, 200);
      doc.line(x + margin, currentY, x + halfWidth - margin, currentY);
      currentY += 12;

      doc.setFontSize(10);
      doc.setFont("helvetica", "bold");
      doc.text("INFORMAÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¯ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¿ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â½?ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¯ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¿ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â½.ES DO PACIENTE", x + margin, currentY);

      doc.setFont("helvetica", "normal");
      doc.setFontSize(8);
      const pacienteText = doc.splitTextToSize(
        `Paciente: ${item.paciente.nmPaciente || "NÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â£o informado"}`,
        halfWidth - margin * 2,
      );
      doc.text(pacienteText, x + margin, currentY + 18);

      const enderecoPacienteText = doc.splitTextToSize(
        `EndereÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â§o: ${item.paciente.nmEndereco || "NÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â£o informado"}`,
        halfWidth - margin * 2,
      );
      doc.text(enderecoPacienteText, x + margin, currentY + 32);

      const enderecoPacienteHeight = enderecoPacienteText.length * 9;
      currentY += 32 + enderecoPacienteHeight + 8;

      doc.line(x + margin, currentY, x + halfWidth - margin, currentY);
      currentY += 12;

      doc.setFontSize(10);
      doc.setFont("helvetica", "bold");
      doc.text("PRESCRIÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¯ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¿ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â½?ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¯ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¿ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â½fO MÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¯ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¿ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â½?DICA", x + margin, currentY);

      doc.setFont("helvetica", "normal");
      doc.setFontSize(8);

      const tempDiv = document.createElement("div");
      tempDiv.innerHTML = item.prescricao;
      const prescricaoText = tempDiv.textContent || tempDiv.innerText || "";
      const splitPrescricao = doc.splitTextToSize(
        prescricaoText,
        halfWidth - margin * 2,
      );

      currentY += 18;
      for (let i = 0; i < splitPrescricao.length; i++) {
        if (currentY > pageHeight - footerHeight - 20) {
          addFooter(x, pageHeight - footerHeight);
          doc.addPage();
          currentY = margin;
          await addWatermark(x, currentY, 180);
          const newLogoHeight = await addHeader(x, currentY);
          currentY += newLogoHeight + 35;
        }
        doc.text(splitPrescricao[i], x + margin, currentY);
        currentY += 11;
      }

      currentY += 18;

      const signatureLineLength = (halfWidth - margin * 2) * 0.6;
      const signatureLineX = x + (halfWidth - signatureLineLength) / 2;
      doc.setDrawColor(0, 0, 0);
      doc.line(
        signatureLineX,
        currentY,
        signatureLineX + signatureLineLength,
        currentY,
      );

      doc.setFontSize(8);
      doc.setFont("helvetica", "bold");
      doc.text(
        "CARIMBO E ASSINATURA DO MÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¯ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¿ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â½?DICO",
        x + halfWidth / 2,
        currentY + 12,
        { align: "center" },
      );

      doc.setFont("helvetica", "normal");
      doc.setFontSize(8);
      doc.text(`CRM: ${crm}`, x + halfWidth / 2, currentY + 24, {
        align: "center",
      });

      const dataAtual = new Date().toLocaleDateString("pt-BR");
      doc.text(`Data: ${dataAtual}`, x + margin, currentY + 27);
      currentY += 45;

      const colWidth = (halfWidth - margin * 2 - 20) / 2;
      doc.setFont("helvetica", "bold");
      doc.setFontSize(9);
      doc.text(
        "IDENTIFICAÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¯ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¿ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â½?ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¯ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¿ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â½fO DO COMPRADOR",
        x + margin + colWidth / 2,
        currentY,
        { align: "center" },
      );

      doc.setFont("helvetica", "normal");
      doc.setFontSize(8);
      doc.text("Nome: ______________________", x + margin, currentY + 18);
      doc.text(
        "Ident.: ____________ OrgÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â£o Emissor: ______",
        x + margin,
        currentY + 32,
      );
      doc.text("End.: _________________________", x + margin, currentY + 46);
      doc.text(
        "Cidade: _____________________ UF: _____",
        x + margin,
        currentY + 60,
      );
      doc.text("Telefone: ____________", x + margin, currentY + 74);

      doc.setDrawColor(200, 200, 200);
      doc.line(
        x + margin + colWidth + 10,
        currentY,
        x + margin + colWidth + 10,
        currentY + 85,
      );

      const rightColX = x + margin + colWidth + 20;
      doc.setFont("helvetica", "bold");
      doc.setFontSize(9);
      doc.text(
        "IDENTIFICAÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¯ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¿ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â½?ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¯ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¿ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â½fO DO FORNECEDOR",
        rightColX + colWidth / 2,
        currentY,
        { align: "center" },
      );

      doc.setFont("helvetica", "normal");
      doc.setFontSize(8);
      doc.text("Assinatura do FarmacÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Âªutico:", rightColX, currentY + 18);

      doc.setDrawColor(0, 0, 0);
      doc.line(rightColX, currentY + 22, rightColX + colWidth, currentY + 22);
      doc.text("Data: ____/____/_____", rightColX, currentY + 40);

      addFooter(x, pageHeight - footerHeight + 35);
    };

    await drawContent(0, 0);
    await drawContent(halfWidth, 0);

    doc.setDrawColor(0, 0, 0);
    doc.setLineWidth(1);
    doc.line(halfWidth, 0, halfWidth, pageHeight);

    const pdfBlob = doc.output("blob");
    const pdfUrl = URL.createObjectURL(pdfBlob);

    const iframe = document.createElement("iframe");
    iframe.style.display = "none";
    iframe.src = pdfUrl;
    document.body.appendChild(iframe);

    iframe.onload = function () {
      setTimeout(function () {
        iframe.contentWindow?.print();
      }, 500);
    };

    return pdfBlob;
  };

  const visualizarReceituarioLaudo = (item: ReceituarioLaudo) => {
    const htmlToFormattedText = (html: string): string => {
      const tempDiv = document.createElement("div");
      tempDiv.innerHTML = html;

      const processNode = (node: Node): string => {
        if (node.nodeType === Node.TEXT_NODE) {
          return node.textContent?.replace(/\s+/g, " ") || "";
        } else if (node.nodeType === Node.ELEMENT_NODE) {
          const element = node as HTMLElement;

          switch (element.tagName.toLowerCase()) {
            case "p":
              return (
                Array.from(element.childNodes).map(processNode).join("") + "\n"
              );
            case "br":
              return "\n";
            case "div":
              return (
                Array.from(element.childNodes).map(processNode).join("") + "\n"
              );
            case "strong":
            case "b":
              return Array.from(element.childNodes).map(processNode).join("");
            case "em":
            case "i":
              return Array.from(element.childNodes).map(processNode).join("");
            case "ul":
              return Array.from(element.children)
                .map((li) => "ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¯ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¿ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â½?ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¯ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¿ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â½ " + processNode(li) + "\n")
                .join("");
            case "ol":
              return Array.from(element.children)
                .map((li, index) => index + 1 + ". " + processNode(li) + "\n")
                .join("");
            case "li":
              return Array.from(element.childNodes)
                .map(processNode)
                .join("")
                .trim();
            default:
              return Array.from(element.childNodes).map(processNode).join("");
          }
        }
        return "";
      };

      let result = Array.from(tempDiv.childNodes).map(processNode).join("");

      result = result
        .replace(/\n\s*\n/g, "\n")
        .replace(/\n{3,}/g, "\n\n")
        .replace(/[ \t]+/g, " ")
        .trim();

      return result;
    };

    const formatDate = (dateString: string) => {
      if (!dateString) return "";
      const date = new Date(dateString);
      return date.toLocaleDateString("pt-BR");
    };

    const diasPorExtenso = (dias: number) => {
      if (dias === 0) return "zero";
      const unidades = [
        "",
        "um",
        "dois",
        "trÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Âªs",
        "quatro",
        "cinco",
        "seis",
        "sete",
        "oito",
        "nove",
      ];
      const dezenas = [
        "",
        "dez",
        "vinte",
        "trinta",
        "quarenta",
        "cinquenta",
        "sessenta",
        "setenta",
        "oitenta",
        "noventa",
      ];
      const especiais = [
        "dez",
        "onze",
        "doze",
        "treze",
        "quatorze",
        "quinze",
        "dezesseis",
        "dezessete",
        "dezoito",
        "dezenove",
      ];

      if (dias < 10) return unidades[dias];
      if (dias < 20) return especiais[dias - 10];
      if (dias < 100) {
        const dezena = Math.floor(dias / 10);
        const unidade = dias % 10;
        return dezenas[dezena] + (unidade > 0 ? " e " + unidades[unidade] : "");
      }
      return dias.toString();
    };

    const formatAtestadoContent = (item: ReceituarioLaudo) => {
      const diasAfastamento = item.atestadoQtdDias || 0;
      const diasEscritoAfastamento = diasPorExtenso(diasAfastamento);
      const dataAtestado =
        formatDate(item.dtConsulta) || new Date().toLocaleDateString("pt-BR");

      return `
      <div style="margin-bottom: 8px; font-size: 11px; line-height: 1.4; text-align: justify;">
        <p>
          Atesto, para os devidos fins, a pedido do interessado, que o Sr.(a) ${
            item.paciente.nmPaciente
          }, 
          portador do CPF: ${
            item.paciente.nuCpf
          } foi submetido ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â  consulta nesta data, no horÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¡rio das 
          ${
            item.hrConsulta || "nÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â£o informado"
          }, sendo portador de afecÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â§ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â£o CID-${item.cid || "nÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â£o informado"}.
        </p>
        
        <p style="margin-top: 8px;">
          Em decorrÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Âªncia deverÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¡ permanecer afastado de suas atividades laborativas por um perÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â­odo de 
          ${diasAfastamento} (${diasEscritoAfastamento}) dia(s) a partir desta data. JoÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â£o Pessoa, ${dataAtestado}.
        </p>
      </div>
      
      <div style="margin: 15px 0; text-align: center; font-size: 10px;">
        <div style="border-top: 1px solid #000; width: 60%; margin: 0 auto; padding-top: 3px;"></div>
        <p style="font-weight: 600; margin-top: 4px;">Dr. ${
          item.profissional.nmProfissional
        }</p>     
      </div>
      
      <div style="margin-top: 15px; text-align: center; font-size: 10px;">
        <h4 style="color: #2463EB; font-size: 12px; margin-bottom: 8px;">AutorizaÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â§ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â£o</h4>
        <p style="text-align: justify; line-height: 1.4;">
          Eu, ${item.paciente.nmPaciente}, autorizo o Dr. ${
            item.profissional.nmProfissional
          } 
          a registrar o diagnÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â³stico (codificado - CID: ${
            item.cid || "nÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â£o informado"
          } ou por extenso) neste atestado.
        </p>
        
        <div style="margin: 15px 0; text-align: center;">
          <div style="border-top: 1px solid #000; width: 60%; margin: 0 auto; padding-top: 3px;"></div>
          <p style="margin-top: 4px;">Assinatura do UsuÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¡rio - RG</p>
        </div>
      </div>
    `;
    };

    const formatPrescricaoContent = (item: ReceituarioLaudo, tipo: string) => {
      return `
  <div style="margin-bottom: 8px; font-size: 11px; line-height: 1.4;">
    <h4 style="color: #000; font-weight: 600; font-size: 12px; margin-bottom: 6px;">
      ${tipo === "RECEITA" ? "PrescriÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â§ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â£o:" : ""}
    </h4>
    
    <div style="margin-bottom: 1px; padding: 8px; text-align: justify">
      <p style="margin: 2px 0; font-size: 12px;">
        <strong>Paciente:</strong> ${item.paciente.nmPaciente}
      </p> 
    </div>
    
    <div style="text-align: justify; white-space: pre-wrap;">
      ${htmlToFormattedText(item.prescricao)}
    </div>
  </div>
  
  <div style="margin: 15px 0; text-align: center; font-size: 10px;">
    <div style="border-top: 1px solid #000; width: 60%; margin: 0 auto; padding-top: 3px;"></div>
    <p style="font-weight: 600; margin-top: 4px;">Dr. ${
      item.profissional.nmProfissional
    }</p>     
  </div>
`;
    };

    const formatPrescricaofISIOContent = (
      item: ReceituarioLaudo,
      tipo: string,
    ) => {
      return `
      <div style="margin-bottom: 8px; font-size: 11px; line-height: 1.4;">
        <h4 style="color: #000; font-weight: 600; font-size: 12px; margin-bottom: 6px;">
          ${tipo === "RECEITA" ? "PrescriÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â§ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â£o:" : ""}
        </h4>
        <div style="text-align: justify; white-space: pre-wrap;">
          <p style="margin: 2px 0; font-size: 12px;">
        <strong>Paciente:</strong> ${item.paciente.nmPaciente}
      </p>   </div>
        <div style="text-align: justify; white-space: pre-wrap;">
          ${htmlToFormattedText(item.prescricao)}
        </div>
      </div>
      
      <div style="margin: 15px 0; text-align: center; font-size: 10px;">
        <div style="border-top: 1px solid #000; width: 60%; margin: 0 auto; padding-top: 3px;"></div>
        <p style="font-weight: 600; margin-top: 4px;">Dr. ${
          item.profissional.nmProfissional
        }</p>     
      </div>
    `;
    };

    const formatReceituarioEspecialContent = (item: ReceituarioLaudo) => {
      const enderecoPaciente = item.paciente.nuEndereco || "NÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â£o informado";
      const crm = Cookies.get("CRM") || "NÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â£o informado";

      return `
      <div style="margin-bottom: 8px; text-align: left; font-size: 11px; line-height: 1.4;">
        <h4 style="color: #000; font-weight: 600; font-size: 12px; margin-bottom: 6px;">IDENTIFICAÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¯ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¿ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â½?ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¯ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¿ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â½fO DO EMITENTE</h4>
        <p><strong>Nome completo:</strong> Dr. ${
          item.profissional.nmProfissional
        }</p>
        <p><strong>CNPJ:</strong> 09.306.242/0001-82</p>
        <p><strong>EndereÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â§o completo e Telefone:</strong> Rua CorÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¡lio Soares de Oliveira ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¯ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¿ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â½?" 497, Centro (83) 3533.5310</p>
        <p><strong>Cidade:</strong> JoÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â£o Pessoa</p>
        <p><strong>UF:</strong> ParaÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â­ba</p>
      </div>

      <hr style="margin: 8px 0; border: 0; border-top: 1px solid #ccc;">

      <div style="margin-bottom: 8px; text-align: left; font-size: 11px; line-height: 1.4;">
        <h4 style="color: #000; font-weight: 600; font-size: 12px; margin-bottom: 6px;">INFORMAÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¯ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¿ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â½?ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¯ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¿ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â½.ES DO PACIENTE</h4>
        <p><strong>Paciente:</strong> ${item.paciente.nmPaciente}</p>
        <p><strong>EndereÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â§o:</strong> ${enderecoPaciente}</p>
      </div>

      <hr style="margin: 8px 0; border: 0; border-top: 1px solid #ccc;">

      <div style="margin-bottom: 8px; font-size: 11px;">
        <h4 style="color: #000; font-weight: 600; font-size: 12px; margin-bottom: 6px;">PRESCRIÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¯ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¿ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â½?ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¯ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¿ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â½fO MÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¯ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¿ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â½?DICA</h4>
        <div style="text-align: justify; line-height: 1.4; white-space: pre-wrap;">
          ${htmlToFormattedText(item.prescricao)}
        </div>
      </div>

      <div style="margin: 15px 0; text-align: center; font-size: 10px;">
        <div style="border-top: 1px solid #000; width: 60%; margin: 0 auto;"></div>
        <p style="font-weight: 600; margin-top: 4px;">CARIMBO E ASSINATURA DO MÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¯ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¿ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â½?DICO</p>
        <p style="font-weight: 500; margin-top: 2px; font-size: 9px;">CRM: ${crm}</p>
        <p style="margin-top: 10px; text-align: left; font-size: 10px;"><strong>Data:</strong> ${
          formatDate(item.dtConsulta) || new Date().toLocaleDateString("pt-BR")
        }</p>
      </div>

      <div style="display: flex; justify-content: space-between; margin-top: 15px; font-size: 10px;">
        <div style="width: 48%; text-align: left;">
          <h4 style="color: #000; font-weight: 600; font-size: 12px; margin-bottom: 4px; border-bottom: 1px solid #ddd; padding-bottom: 3px;">
            IDENTIFICAÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¯ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¿ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â½?ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¯ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¿ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â½fO DO COMPRADOR
          </h4>
          <p style="margin: 4px 0;"><strong>Nome:</strong> __________________________________</p>
          <p style="margin: 4px 0;"><strong>Ident.:</strong> ___________________ <strong>OrgÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â£o Emissor:</strong> ______</p>
          <p style="margin: 4px 0;"><strong>End.:</strong> _________________________</p>
          <p style="margin: 4px 0;"><strong>Cidade:</strong> __________________________ <strong>UF:</strong> _____</p>
          <p style="margin: 4px 0;"><strong>Telefone:</strong> _________________</p>
        </div>

        <div style="width: 48%;">
          <h4 style="color: #000; font-weight: 600; font-size: 12px; text-align: center; margin-bottom: 4px;">IDENTIFICAÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¯ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¿ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â½?ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¯ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¿ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â½fO DO FORNECEDOR</h4>
          <p>Assinatura do FarmacÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Âªutico: _______________________________</p>
          <p>Data: _____/______/__________</p>
        </div>
      </div>
    `;
    };

    const formatOftalmoContent = (item: ReceituarioLaudo) => {
      const hasOftalmoData =
        item.odEsfLong ||
        item.odCilLong ||
        item.odEixoLong ||
        item.odPrismaLong ||
        item.odBaseLong ||
        item.oeEsfLong ||
        item.oeCilLong ||
        item.oeEixoLong ||
        item.oePrismaLong ||
        item.oeBaseLong ||
        item.odEsfPerto ||
        item.odCilPerto ||
        item.odEixoPerto ||
        item.odPrismaPerto ||
        item.odBasePerto ||
        item.oeEsfPerto ||
        item.oeCilPerto ||
        item.oeEixoPerto ||
        item.oePrismaPerto ||
        item.oeBasePerto;

      if (!hasOftalmoData) {
        return `
      <div style="text-align: center; padding: 20px; color: #666;">
        <p>Nenhum dado oftalmolÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â³gico encontrado para este receituario.</p>
      </div>
    `;
      }

      const formatValue = (value: any) => value || "-";

      return `
    <div style="margin-bottom: 15px;">
      <div style="display: flex; justify-content: space-between; margin-bottom: 20px;">
        <div style="width: 48%; text-align: center;">
          <img src="/od.svg" alt="Olho Direito" style="width: 600px; height: 200px; margin-bottom: 10px;">
          <p style="font-weight: bold;">OD - Olho Direito</p>
        </div>
        <div style="width: 48%; text-align: center;">
          <img src="/oe.svg" alt="Olho Esquerdo" style="width: 600px; height: 200px; margin-bottom: 10px;">
          <p style="font-weight: bold;">OE - Olho Esquerdo</p>
        </div>
      </div>

      ${
        item.odEsfLong ||
        item.odCilLong ||
        item.odEixoLong ||
        item.odPrismaLong ||
        item.odBaseLong ||
        item.oeEsfLong ||
        item.oeCilLong ||
        item.oeEixoLong ||
        item.oePrismaLong ||
        item.oeBaseLong
          ? `
      <div style="margin-bottom: 15px;">
        <h4 style="color: #000; font-weight: 600; font-size: 12px; margin-bottom: 8px; border-bottom: 1px solid #ddd; padding-bottom: 3px;">LONGE</h4>
        <table style="width: 100%; border-collapse: collapse; font-size: 11px;">
          <thead>
            <tr style="background-color: #f2f2f2;">
              <th style="border: 1px solid #ddd; padding: 8px; text-align: center;">Olho</th>
              <th style="border: 1px solid #ddd; padding: 8px; text-align: center;">Esf.</th>
              <th style="border: 1px solid #ddd; padding: 8px; text-align: center;">Cil.</th>
              <th style="border: 1px solid #ddd; padding: 8px; text-align: center;">Eixo</th>
              <th style="border: 1px solid #ddd; padding: 8px; text-align: center;">Prisma</th>
              <th style="border: 1px solid #ddd; padding: 8px; text-align: center;">Base</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td style="border: 1px solid #ddd; padding: 8px; text-align: center; font-weight: bold;">OD</td>
              <td style="border: 1px solid #ddd; padding: 8px; text-align: center;">${formatValue(
                item.odEsfLong,
              )}</td>
              <td style="border: 1px solid #ddd; padding: 8px; text-align: center;">${formatValue(
                item.odCilLong,
              )}</td>
              <td style="border: 1px solid #ddd; padding: 8px; text-align: center;">${formatValue(
                item.odEixoLong,
              )}</td>
              <td style="border: 1px solid #ddd; padding: 8px; text-align: center;">${formatValue(
                item.odPrismaLong,
              )}</td>
              <td style="border: 1px solid #ddd; padding: 8px; text-align: center;">${formatValue(
                item.odBaseLong,
              )}</td>
            </tr>
            <tr>
              <td style="border: 1px solid #ddd; padding: 8px; text-align: center; font-weight: bold;">OE</td>
              <td style="border: 1px solid #ddd; padding: 8px; text-align: center;">${formatValue(
                item.oeEsfLong,
              )}</td>
              <td style="border: 1px solid #ddd; padding: 8px; text-align: center;">${formatValue(
                item.oeCilLong,
              )}</td>
              <td style="border: 1px solid #ddd; padding: 8px; text-align: center;">${formatValue(
                item.oeEixoLong,
              )}</td>
              <td style="border: 1px solid #ddd; padding: 8px; text-align: center;">${formatValue(
                item.oePrismaLong,
              )}</td>
              <td style="border: 1px solid #ddd; padding: 8px; text-align: center;">${formatValue(
                item.oeBaseLong,
              )}</td>
            </tr>
          </tbody>
        </table>
      </div>
      `
          : ""
      }

      ${
        item.odEsfPerto ||
        item.odCilPerto ||
        item.odEixoPerto ||
        item.odPrismaPerto ||
        item.odBasePerto ||
        item.oeEsfPerto ||
        item.oeCilPerto ||
        item.oeEixoPerto ||
        item.oePrismaPerto ||
        item.oeBasePerto
          ? `
      <div style="margin-bottom: 15px;">
        <h4 style="color: #000; font-weight: 600; font-size: 12px; margin-bottom: 8px; border-bottom: 1px solid #ddd; padding-bottom: 3px;">PERTO</h4>
        <table style="width: 100%; border-collapse: collapse; font-size: 11px;">
          <thead>
            <tr style="background-color: #f2f2f2;">
              <th style="border: 1px solid #ddd; padding: 8px; text-align: center;">Olho</th>
              <th style="border: 1px solid #ddd; padding: 8px; text-align: center;">Esf.</th>
              <th style="border: 1px solid #ddd; padding: 8px; text-align: center;">Cil.</th>
              <th style="border: 1px solid #ddd; padding: 8px; text-align: center;">Eixo</th>
              <th style="border: 1px solid #ddd; padding: 8px; text-align: center;">Prisma</th>
              <th style="border: 1px solid #ddd; padding: 8px; text-align: center;">Base</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td style="border: 1px solid #ddd; padding: 8px; text-align: center; font-weight: bold;">OD</td>
              <td style="border: 1px solid #ddd; padding: 8px; text-align: center;">${formatValue(
                item.odEsfPerto,
              )}</td>
              <td style="border: 1px solid #ddd; padding: 8px; text-align: center;">${formatValue(
                item.odCilPerto,
              )}</td>
              <td style="border: 1px solid #ddd; padding: 8px; text-align: center;">${formatValue(
                item.odEixoPerto,
              )}</td>
              <td style="border: 1px solid #ddd; padding: 8px; text-align: center;">${formatValue(
                item.odPrismaPerto,
              )}</td>
              <td style="border: 1px solid #ddd; padding: 8px; text-align: center;">${formatValue(
                item.odBasePerto,
              )}</td>
            </tr>
            <tr>
              <td style="border: 1px solid #ddd; padding: 8px; text-align: center; font-weight: bold;">OE</td>
              <td style="border: 1px solid #ddd; padding: 8px; text-align: center;">${formatValue(
                item.oeEsfPerto,
              )}</td>
              <td style="border: 1px solid #ddd; padding: 8px; text-align: center;">${formatValue(
                item.oeCilPerto,
              )}</td>
              <td style="border: 1px solid #ddd; padding: 8px; text-align: center;">${formatValue(
                item.oeEixoPerto,
              )}</td>
              <td style="border: 1px solid #ddd; padding: 8px; text-align: center;">${formatValue(
                item.oePrismaPerto,
              )}</td>
              <td style="border: 1px solid #ddd; padding: 8px; text-align: center;">${formatValue(
                item.oeBasePerto,
              )}</td>
            </tr>
          </tbody>
        </table>
      </div>
      `
          : ""
      }

      ${
        item.prescricao
          ? `
      <div style="margin-bottom: 15px;">
        <h4 style="color: #000; font-weight: 600; font-size: 12px; margin-bottom: 8px;">OBSERVAÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¯ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¿ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â½?ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¯ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¿ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â½.ES</h4>
        <div style="text-align: justify; white-space: pre-wrap; font-size: 11px; line-height: 1.4;">
          ${htmlToFormattedText(item.prescricao)}
        </div>
      </div>
      `
          : ""
      }
    </div>

    <div style="margin: 15px 0; text-align: center; font-size: 10px;">
      <div style="border-top: 1px solid #000; width: 60%; margin: 0 auto; padding-top: 3px;"></div>
      <p style="font-weight: 600; margin-top: 4px;">Dr. ${
        item.profissional.nmProfissional
      }</p>
    </div>
  `;
    };

    let content = "";
    let title = "";

    switch (item.tipo) {
      case "ATESTADO":
        title = "ATESTADO MÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¯ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¿ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â½?DICO";
        content = formatAtestadoContent(item);
        break;
      case "LAUDO":
        title = "LAUDO";
        content = formatPrescricaoContent(item, "LAUDO");
        break;
      case "RECEITA":
        title = "RECEITUARIO COMUM";
        content = formatPrescricaoContent(item, "RECEITA");
        break;
      case "RECEITA_ESPECIAL":
        title = "RECEITUARIO ESPECIAL";
        content = formatReceituarioEspecialContent(item);
        break;
      case "OFTALMO":
        title = "OFTALMOLOGICO";
        content = formatOftalmoContent(item);
        break;
      case "ALTA_FISIO":
        title = "ALTA FISIOTERAPIA";
        content = formatPrescricaofISIOContent(item, "ALTA_FISIO");
        break;
      default:
        title = item.tipo.replace(/_/g, " ");
        content = htmlToFormattedText(item.prescricao);
    }

    const generatePDF = () => {
      switch (item.tipo) {
        case "ATESTADO":
          handleGenerateAtestadoPDF(item);
          break;
        case "LAUDO":
          handleGenerateLaudoPDF(item);
          break;
        case "RECEITA":
          handleGenerateReceituarioPDF(item);
          break;
        case "RECEITA_ESPECIAL":
          handleGenerateReceituarioEspecialPDF(item);
          break;
        case "OFTALMO":
          handleGenerateOftalmoPDF(item);
          break;
        case "ALTA_FISIO":
          handleGenerateAltaFisioPDF(item);
          break;
        default:
          break;
      }
    };

    Swal.fire({
      title: `<div style="color: #2463EB; font-size: 15px; font-weight: bold; margin-bottom: 10px;">
      <img src="${Logo}" alt="Logo" style="width: 100%; max-width: 800px; height: auto; margin: 0 auto;">
      <p style="color: #2463EB; font-size: 12px; margin-top: 10px;">
        AssociaÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â§ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â£o dos Auditores Fiscais do Estado da ParaÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â­ba
      </p>
      ${title}
    </div>`,
      html: `
      <div style="max-width: 800px; margin: 0 auto; font-family: Arial, sans-serif; color: #333;">
        <div style="text-align: center; margin-bottom: 10px;">
          ${
            item.tipo === "RECEITA_ESPECIAL"
              ? `
            <div style="text-align: right; font-size: 10px; margin-top: 5px;">
              <p>1ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Âª Via - RetenÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â§ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â£o da FarmÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¡cia ou Drogaria</p>
              <p>2ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Âª Via - OrientaÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â§ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â£o ao Paciente</p>
            </div>
          `
              : ""
          }
        </div>
        
        <div style="background-color: white; padding: 20px; border-radius: 5px;">
          ${content}
        </div>
        
        <div style="margin-top: 30px; font-size: 9px; display: flex; justify-content: space-between;">
          <div style="width: 48%; color: #2463EB;">
            <p>Rua CorÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¡lio Soares de Oliveira, 497 ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¯ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¿ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â½?ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¯ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¿ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â½ Centro, JoÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â£o Pessoa ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¯ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¿ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â½?ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¯ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¿ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â½ PB</p>
            <p>Fone: (83) 3533.5310 | 3533.5311</p>
            <p>www.afrafep.org.br</p>
            <p>INSC. ANS NÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â° 330281</p>
          </div>
          
          <div style="width: 48%; text-align: right; color: #2463EB;">
            <p>ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¯ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¿ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â½?tica e TransparÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Âªncia</p>
            <p>Solidariedade e Responsabilidade Social</p>
            <p>Comprometimento e Profissionalismo</p>
            <p>Legalidade e Respeito</p>
          </div>
        </div>
      </div>
    `,
      width: "850px",
      showCloseButton: true,
      showConfirmButton: false,
      footer: `
      <button id="print-pdf-btn" style="
        background-color: #2463EB;
        color: white;
        border: none;
        padding: 10px 20px;
        border-radius: 4px;
        cursor: pointer;
        font-weight: bold;
        font-size: 14px;
      ">
        <i class="fas fa-print"></i> Imprimir Documento
      </button>
    `,
      didOpen: () => {
        const printBtn = document.getElementById("print-pdf-btn");
        if (printBtn) {
          printBtn.addEventListener("click", generatePDF);
        }
      },
    });
  };

  const handleGenerateOftalmoPDF = async (item: ReceituarioLaudo) => {
    const agora = new Date();
    const dataHoraAtual = agora.toLocaleString("pt-BR", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });

    const doc = new jsPDF({
      orientation: "portrait",
      unit: "pt",
      format: "a4",
    });
    const marginLeft = 40;
    const marginRight = 40;
    const marginTop = 20;
    const pageWidth =
      doc.internal.pageSize.getWidth() - marginLeft - marginRight;
    const pageHeight = doc.internal.pageSize.getHeight();
    const centerX = doc.internal.pageSize.getWidth() / 2;
    let currentY = marginTop;

    const addFooter = () => {
      const additionalInfo = [
        "Rua: Coralio Soares de Oliveira, nÃ‚Âº 497, Centro, Joao Pessoa - PB, CEP 58.013-260.",
        "Telefone: 3533-5310 - www.afrafepsaude.com.br  @afrafepsaude",
        "CNPJ: 09.306.242/0001-82.",
      ];

      doc.setTextColor(105, 105, 105);
      let yOffset = pageHeight - 80;

      additionalInfo.forEach((line) => {
        const splitText = doc.splitTextToSize(line, 300);
        splitText.forEach((textLine: any) => {
          doc.text(textLine, 25, yOffset);
          yOffset += 10;
        });
        yOffset += 5;
      });

      const imgWidth = 180;
      const imgHeight = 80;
      const xOffsetImage = doc.internal.pageSize.width - imgWidth - 40;
      const yOffsetImage = pageHeight - imgHeight - 17;
      doc.addImage(
        rodape,
        "PNG",
        xOffsetImage,
        yOffsetImage,
        imgWidth,
        imgHeight,
      );
    };

    const addHeader = async () => {
      const logoImg = new Image();
      logoImg.src = Logo;
      await new Promise<void>((resolve) => {
        logoImg.onload = () => {
          const imgWidth = doc.internal.pageSize.getWidth();
          const imgHeight = (logoImg.height * imgWidth) / logoImg.width;
          doc.addImage(Logo, "PNG", 0, 0, imgWidth, imgHeight);
          currentY = imgHeight + 30;
          resolve();
        };
        logoImg.onerror = (err) => {
          console.error("Erro ao carregar o logo:", err);
          resolve();
        };
      });
    };

    const addWatermark = async () => {
      await new Promise<void>((resolve) => {
        const watermarkImg = new Image();
        watermarkImg.src = WatermarkLogo;
        watermarkImg.onload = () => {
          const watermarkWidth = 350;
          const watermarkHeight =
            (watermarkImg.height * watermarkWidth) / watermarkImg.width;

          const canvas = document.createElement("canvas");
          canvas.width = watermarkImg.width;
          canvas.height = watermarkImg.height;
          const ctx = canvas.getContext("2d");

          if (ctx) {
            ctx.drawImage(watermarkImg, 0, 0);
            const imageData = ctx.getImageData(
              0,
              0,
              canvas.width,
              canvas.height,
            );
            const data = imageData.data;

            for (let i = 0; i < data.length; i += 4) {
              if (data[i] > 150 && data[i + 1] < 80 && data[i + 2] < 80) {
                data[i] = 36;
                data[i + 1] = 99;
                data[i + 2] = 235;
                data[i + 3] = 30;
              } else if (data[i + 3] > 0) {
                data[i + 3] = 30;
              }
            }
            ctx.putImageData(imageData, 0, 0);

            doc.addImage(
              canvas.toDataURL("image/png"),
              "PNG",
              centerX - watermarkWidth / 2,
              pageHeight / 2 - watermarkHeight / 2,
              watermarkWidth,
              watermarkHeight,
              undefined,
              "FAST",
            );
          }
          resolve();
        };
        watermarkImg.onerror = (err) => {
          console.error("Erro ao carregar a imagem da marca d'ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¡gua:", err);
          resolve();
        };
      });
    };

    const formatValue = (value: any) => value || "-";

    const addContent = async () => {
      await addWatermark();
      await addHeader();

      doc.setFontSize(12);
      doc.setFont("helvetica", "normal");
      doc.text(`Nome: ${item.paciente.nmPaciente}`, marginLeft, currentY);
      currentY += 20;

      const protractorWidth = 250;
      const protractorHeight = 150;
      const protractorX1 = marginLeft + 10;
      const protractorX2 = centerX + 10;
      const protractorY = currentY;

      doc.addImage(
        odPng,
        "PNG",
        protractorX1,
        protractorY,
        protractorWidth,
        protractorHeight,
      );
      doc.addImage(
        oePng,
        "PNG",
        protractorX2,
        protractorY,
        protractorWidth,
        protractorHeight,
      );

      currentY += protractorHeight + 30;

      const tablesData = [
        {
          title: "LONGE",
          data: {
            od: {
              esf: item.odEsfLong,
              cil: item.odCilLong,
              eixo: item.odEixoLong,
              prisma: item.odPrismaLong,
              base: item.odBaseLong,
            },
            oe: {
              esf: item.oeEsfLong,
              cil: item.oeCilLong,
              eixo: item.oeEixoLong,
              prisma: item.oePrismaLong,
              base: item.oeBaseLong,
            },
          },
        },
        {
          title: "PERTO",
          data: {
            od: {
              esf: item.odEsfPerto,
              cil: item.odCilPerto,
              eixo: item.odEixoPerto,
              prisma: item.odPrismaPerto,
              base: item.odBasePerto,
            },
            oe: {
              esf: item.oeEsfPerto,
              cil: item.oeCilPerto,
              eixo: item.oeEixoPerto,
              prisma: item.oePrismaPerto,
              base: item.oeBasePerto,
            },
          },
        },
      ];

      for (const table of tablesData) {
        const hasData =
          table.data.od.esf ||
          table.data.od.cil ||
          table.data.od.eixo ||
          table.data.od.prisma ||
          table.data.od.base ||
          table.data.oe.esf ||
          table.data.oe.cil ||
          table.data.oe.eixo ||
          table.data.oe.prisma ||
          table.data.oe.base;

        if (hasData) {
          doc.setFontSize(12);
          doc.setFont("helvetica", "bold");
          doc.text(table.title, marginLeft, currentY);
          currentY += 20;

          const bodyData = [
            [
              "OD",
              formatValue(table.data.od.esf),
              formatValue(table.data.od.cil),
              formatValue(table.data.od.eixo),
              formatValue(table.data.od.prisma),
              formatValue(table.data.od.base),
            ],
            [
              "OE",
              formatValue(table.data.oe.esf),
              formatValue(table.data.oe.cil),
              formatValue(table.data.oe.eixo),
              formatValue(table.data.oe.prisma),
              formatValue(table.data.oe.base),
            ],
          ];

          autoTable(doc, {
            head: [["Olho", "Esf.", "Cil.", "Eixo", "Prisma", "Base"]],
            body: bodyData,
            startY: currentY,
            theme: "grid",
            headStyles: {
              fillColor: [66, 139, 202],
              textColor: [255, 255, 255],
              fontStyle: "bold",
            },
            margin: { left: marginLeft, right: marginRight },
            styles: { fontSize: 10, halign: "center" },
            columnStyles: { 0: { cellWidth: "auto" } },
          });

          currentY = (doc as any).lastAutoTable.finalY + 20;
        }
      }

      if (item.prescricao) {
        if (currentY > pageHeight - 80) {
          doc.addPage();
          currentY = marginTop + 40;
        }
        doc.setFontSize(12);
        doc.setFont("helvetica", "bold");
        doc.text("OBS:", marginLeft, currentY);
        doc.setFont("helvetica", "normal");
        currentY += 15;
        const splitObs = doc.splitTextToSize(item.prescricao, pageWidth);
        doc.text(splitObs, marginLeft, currentY);
        currentY += splitObs.length * 15 + 20;
      }

      if (currentY > pageHeight - 100) {
        doc.addPage();
        currentY = marginTop + 40;
      }

      doc.setFontSize(10);

      const signatureLineWidth = 200;
      const signatureLineX = centerX - signatureLineWidth / 2;

      doc.line(
        signatureLineX,
        currentY + 60,
        signatureLineX + signatureLineWidth,
        currentY + 60,
      );

      doc.text("Carimbo e Assinatura do MÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â©dico", centerX, currentY + 75, {
        align: "center",
      });

      doc.text(`${item.profissional.nmProfissional}`, centerX, currentY + 90, {
        align: "center",
      });

      doc.text(
        `Data e hora de emissÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â£o: ${dataHoraAtual}`,
        doc.internal.pageSize.getWidth() - marginRight,
        currentY + 20,
        { align: "right" },
      );
      addFooter();
    };

    currentY = marginTop;
    await addContent();

    const totalPages = (doc as any).internal.getNumberOfPages();
    for (let i = 1; i <= totalPages; i++) {
      doc.setPage(i);
      doc.setFontSize(8);
      doc.setTextColor(100);
      doc.text(`Pagina ${i} de ${totalPages}`, centerX, pageHeight - 20, {
        align: "center",
      });
    }

    const pdfBlob = doc.output("blob");
    const pdfUrl = URL.createObjectURL(pdfBlob);

    const iframe = document.createElement("iframe");
    iframe.style.display = "none";
    iframe.src = pdfUrl;
    document.body.appendChild(iframe);

    iframe.onload = function () {
      setTimeout(function () {
        iframe.contentWindow?.print();
      }, 500);
    };

    return pdfBlob;
  };

  const renderReceituarioLaudo = (item: ReceituarioLaudo) => {
    const [ano, mes, dia] = item.dtConsulta.split("-");
    const dataFormatada = `${dia}/${mes}/${ano}`;

    return (
      <div
        key={item.id}
        onClick={() => visualizarReceituarioLaudo(item)}
        className="mb-2 p-3 border rounded-lg bg-gray-50 shadow-sm hover:shadow transition cursor-pointer"
      >
        <div className="flex items-center justify-between mb-1">
          <span className="text-xs text-black-800">
            <span className="font-semibold">
              {item.tipo.replace(/_/g, " ")}
            </span>{" "}
            - {dataFormatada}
          </span>
          <MousePointerClick className="text-black-600 text-base" />
        </div>
      </div>
    );
  };

  useEffect(() => {
    fetchReceituariosLaudos();
  }, [fetchReceituariosLaudos]);

  const toggleTab = (
    tab: "meus" | "outros" | "sadt" | "receituarios" | "altas",
  ) => {
    setActiveTab((prev) => (prev === tab ? null : tab));
  };

  const handleDtInicioChange = (e: any) => {
    const newDtInicio = e.target.value;
    setDtInicio(newDtInicio);

    const dtInicioObj = new Date(newDtInicio);
    dtInicioObj.setFullYear(dtInicioObj.getFullYear() + 1);

    const formattedDtFim = dtInicioObj.toISOString().split("T")[0];
    setDtFim(formattedDtFim);
  };

  const handleSubmit = async () => {
    if (!dtInicio) {
      toast.error("Por favor, preencha a data de inÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â­cio.");
      return;
    }

    if (!dtFim) {
      toast.error("Por favor, preencha a data de fim.");
      return;
    }

    if (!status) {
      toast.error("Por favor, selecione um status.");
      return;
    }

    const dataToSend = {
      cdPaciente: cdPaciente2,
      nuCpf: NuCPF,
      idEspecialidade,
      dtInicio,
      dtFim,
      status,
    };

    setTimeout(async () => {
      try {
        await api.post("/sisclinic/mais-saude", dataToSend);
        toast.success("Dados enviados com sucesso!");

        setDtInicio("");
        setDtFim("");
        setStatus("");
        setIdEspecialidade("");

        closeModal();
      } catch (error) {
        toast.error("Erro ao enviar os dados!");
      }
    }, 1000);
  };

  const handlePageChange = (page: number) => {
    setCurrentPage(page);
  };

  const [currentPages, setCurrentPages] = useState<Record<number, number>>({});

  const handlePageChange2 = (profissionalId: number, page: number) => {
    setCurrentPages((prev) => ({
      ...prev,
      [profissionalId]: page,
    }));
  };

  const LIMITE_CARACTERES = 4000000;

  const handleChange = (content: string) => {
    const trimmed = content.substring(0, LIMITE_CARACTERES);
    setProntuarioAtual(trimmed);
  };

  // FUNÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¯ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¿ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â½?ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¯ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¿ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â½fO MODIFICADA COM AS REGRAS DE EDIÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¯ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¿ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â½?ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¯ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¿ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â½fO
  const salvarProntuario = () => {
    const textoLimpo = prontuarioAtual.replace(/[\s\u200B-\u200D\uFEFF]/g, "");
    if (!textoLimpo) {
      Swal.fire("Erro", "O campo de evoluÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â§ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â£o nÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â£o pode estar vazio.", "error");
      return;
    }

    // Verificar se estÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¡ tentando editar uma evoluÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â§ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â£o existente
    if (evolucaoEditando) {
      const hoje = new Date();
      const dataEvolucao = new Date(evolucaoEditando.dtHraEvolucao);

      // Verificar se ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â© do dia atual
      const isHoje = hoje.toDateString() === dataEvolucao.toDateString();

      // Verificar se ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â© do local SAD
      const isLocalSAD = evolucaoEditando.localEvolucao === "SAD";

      // SÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â³ permite editar se for do dia E for do local SAD
      if (!isHoje || !isLocalSAD) {
        Swal.fire({
          icon: "warning",
          title: "EdiÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â§ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â£o nÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â£o permitida",
          text: !isHoje
            ? "VocÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Âª sÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â³ pode editar evoluÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â§ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Âµes do dia atual."
            : "VocÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Âª sÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â³ pode editar evoluÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â§ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Âµes do local SAD.",
          confirmButtonText: "Entendi",
        });
        return;
      }
    }

    Swal.fire({
      title: "VocÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Âª realmente deseja salvar as alteraÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â§ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Âµes?",
      text: "As alteraÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â§ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Âµes nÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â£o poderÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â£o ser desfeitas.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Sim, salvar!",
      cancelButtonText: "Cancelar",
    }).then(async (result) => {
      if (!result.isConfirmed) {
        Swal.fire("Atendimento encerrado.", "", "success");
        return;
      }

      setSalvando(true);

      const token = sessionStorage.getItem("token");
      const cdPaciente = Number(Cookies.get("cdPaciente"));
      const nuCpf = Cookies.get("NuCPF") || "";
      const idEvent = Number(Cookies.get("idEvent"));
      const idProfissional = Number(Cookies.get("idProfissional"));

      try {
        if (evolucaoEditando) {
          // Atualiza prontuÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¡rio existente - sÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â³ chega aqui se for do dia e local SAD
          await api.patch(
            `/sisclinic/prontuarios/${evolucaoEditando.idEvolucao}`,
            { dsEvolucao: prontuarioAtual },
            { headers: { Authorization: `Bearer ${token}` } },
          );
          setProntuarioAtualId(evolucaoEditando.idEvolucao);
          setProntuarioAnexosId(evolucaoEditando.idEvolucao);
          setAnexosRefreshKey((prev) => prev + 1);

          Swal.fire("EvoluÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â§ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â£o editada com sucesso!", "", "success");
        } else {
          // Verifica duplicidade para o mesmo profissional no mesmo dia
          const response = await api.get(`/sisclinic/anamnese/cpf/${nuCpf}`, {
            headers: { Authorization: `Bearer ${token}` },
          });

          const evolucoes = response.data;
          const hoje = new Date().toISOString().split("T")[0];

          const jaExisteHoje = evolucoes.some((evo: any) => {
            const dataEvo = evo.dtHraEvolucao?.split("T")[0];
            return (
              dataEvo === hoje &&
              Number(evo.idProfissional) === idProfissional &&
              Number(evo.cdPaciente) === cdPaciente
            );
          });

          if (jaExisteHoje) {
            Swal.fire(
              "JÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¡ existe um prontuÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¡rio!",
              "Este paciente jÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¡ possui uma evoluÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â§ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â£o registrada por vocÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Âª para hoje.",
              "warning",
            );
            setSalvando(false);
            return;
          }

          // Cria novo prontuÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¡rio
          const { data: prontuarioCriado } = await api.post(
            "/sisclinic/prontuarios",
            {
              cdPaciente,
              nuCpf,
              tipo: "EVOLUCAO",
              idProfissional,
              dsEvolucao: prontuarioAtual,
              localEvolucao: "SAD",
              maisSaude: 0,
            },
            {
              headers: { Authorization: `Bearer ${token}` },
            },
          );
          const idCriado =
            Number(prontuarioCriado?.idEvolucao) ||
            Number(prontuarioCriado?.id) ||
            Number(prontuarioCriado?.idProntuario) ||
            null;
          if (idCriado) {
            setProntuarioAtualId(idCriado);
            setProntuarioAnexosId(idCriado);
            setAnexosRefreshKey((prev) => prev + 1);
          }

          // Atualiza status do agendamento
          await fetch(`/agenda/${idEvent}`, {
            method: "PATCH",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify({
              statusAgendamento: "ATENDIDO",
            }),
          });

          Swal.fire("Prontuario salvo com sucesso!", "", "success");
        }

        setEvolucaoEditando(null);
        setProntuarioAtual("");
        navigate("/Sad_Formulario");
      } catch (error) {
        console.error("Erro ao salvar prontuÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¡rio:", error);
        Swal.fire(
          "Erro",
          "NÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â£o foi possÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â­vel salvar os dados. Tente novamente.",
          "error",
        );
      } finally {
        setSalvando(false);
      }
    });
  };

  const atualizar = async () => {
    const cdPaciente = Cookies.get("cdPaciente");
    const token = sessionStorage.getItem("token");

    if (cdPaciente && token) {
      try {
        const response = await api.get(
          `/sisclinic/mais-saude/paciente/${cdPaciente}`,
          {
            headers: {
              "Cache-Control": "no-cache",
              Authorization: `Bearer ${token}`,
            },
          },
        );

        const data = response.data;

        if (Array.isArray(data)) {
          setCiclos(data);
        } else if (data && Array.isArray(data.ciclos)) {
          setCiclos(data.ciclos);
        } else {
          console.warn("Formato inesperado de resposta da API:", data);
        }
      } catch (err) {
        console.error("Erro ao buscar ciclos:", err);
      }
    } else {
      console.error("cdPaciente ou token nÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â£o encontrado");
    }
  };

  // FUNÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¯ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¿ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â½?ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¯ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¿ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â½fO MODIFICADA PARA VERIFICAÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¯ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¿ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â½?ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¯ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¿ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â½fO DE EDIÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¯ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¿ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â½?ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¯ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¿ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â½fO
  const editarEvolucao = (evolucao: Evolucao) => {
    const hoje = new Date();
    const dataEvolucao = new Date(evolucao.dtHraEvolucao);

    // Verificar se ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â© do dia atual
    const isHoje = hoje.toDateString() === dataEvolucao.toDateString();

    // Verificar se ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â© do local SAD
    const isLocalSAD = evolucao.localEvolucao === "SAD";

    if (isHoje && isLocalSAD) {
      // Permite editar se for do dia E for do local SAD
      setProntuarioAtual(evolucao.dsEvolucao);
      setEvolucaoEditando(evolucao);
      setProntuarioAtualId(evolucao.idEvolucao);
      setProntuarioAnexosId(evolucao.idEvolucao);
      setModoEdicao(true);
    } else {
      // Se nÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â£o for do dia ou nÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â£o for SAD, sÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â³ visualizar
      Swal.fire({
        icon: "info",
        title: "Apenas visualizaÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â§ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â£o",
        text: !isHoje
          ? "Esta evoluÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â§ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â£o ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â© de um dia anterior. VocÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Âª sÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â³ pode visualizar."
          : "Esta evoluÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â§ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â£o nÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â£o ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â© do local SAD. VocÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Âª sÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â³ pode visualizar.",
        confirmButtonText: "Entendi",
      });
      visualizarEvolucao(evolucao);
    }
  };

  const visualizarEvolucao = (evolucao?: Evolucao) => {
    if (evolucao && evolucao.dsEvolucao !== prontuarioAtual) {
      setProntuarioAtual(evolucao.dsEvolucao);
      setEvolucaoEditando(evolucao);
      setProntuarioAnexosId(evolucao.idEvolucao);
    }

    setModoEdicao(false);
    setModalAberto(true);
  };

  const visualizarEvolucao2 = (evolucao?: Evolucao) => {
    if (evolucao && evolucao.dsEvolucao) {
      setProntuarioAtual(evolucao.dsEvolucao);
      setEvolucaoEditando(evolucao);
      setProntuarioAnexosId(evolucao.idEvolucao);
    }
    setModoEdicao(false);
    setModalAberto2(true);
  };

  let hasRenderedFaEye = false;

  // FUNÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¯ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¿ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â½?ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¯ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¿ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â½fO MODIFICADA PARA RENDERIZAR BOTÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¯ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¿ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â½.ES CORRETOS
  const renderEvolucao = (evolucao: Evolucao) => {
    const isMesmoProfissional =
      evolucao.idProfissional === Number(Cookies.get("idProfissional"));
    const dataEvolucao = new Date(evolucao.dtHraEvolucao);
    const hoje = new Date();

    const isHoje = hoje.toDateString() === dataEvolucao.toDateString();
    const isLocalSAD = evolucao.localEvolucao === "SAD";

    const isFaEyeButton = isMesmoProfissional && !isHoje;

    if (isFaEyeButton && hasRenderedFaEye) return null;
    if (isFaEyeButton) hasRenderedFaEye = true;

    return (
      <div
        key={evolucao.idEvolucao}
        onClick={() => {
          if (isMesmoProfissional && isHoje && isLocalSAD) {
            // Permite editar se for do mesmo profissional, do dia E do local SAD
            editarEvolucao(evolucao);
            setShowButtons(true);
          } else if (isMesmoProfissional && isHoje && !isLocalSAD) {
            // Se for do dia mas nÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â£o for SAD, sÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â³ visualizar
            setShowButtons(false);
            visualizarEvolucao(evolucao);
          } else if (isMesmoProfissional && !isHoje) {
            // Se nÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â£o for do dia, sÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â³ visualizar (com ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â­cone de olho)
            setShowButtons(false);
            visualizarEvolucao(evolucao);
          } else {
            // Outros profissionais sempre sÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â³ visualizam
            setShowButtons(false);
            visualizarEvolucao2(evolucao);
          }
        }}
        className="mb-2 p-2 border rounded-lg bg-gray-50 shadow-sm hover:shadow transition cursor-pointer"
      >
        {isMesmoProfissional ? (
          <div className="flex items-center justify-between mb-1">
            <span className="text-xs text-gray-900">
              <span className="font-semibold">
                {isHoje && isLocalSAD ? "Editar: " : "Visualizar: "}
              </span>
              {new Date(evolucao.dtHraEvolucao).toLocaleDateString("pt-BR", {
                day: "2-digit",
                month: "2-digit",
                year: "numeric",
              })}
              {!isLocalSAD && " (nÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â£o ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â© SAD)"}
            </span>
            {isHoje && isLocalSAD ? (
              <FaEdit className="text-red-600 w-4 h-4" />
            ) : (
              <FaEye className="text-blue-600 w-4 h-4" />
            )}
          </div>
        ) : (
          <div className="flex items-center justify-between">
            <span className="text-xs text-black">
              <span className="font-semibold">Data:</span>{" "}
              {new Date(evolucao.dtHraEvolucao).toLocaleDateString("pt-BR", {
                day: "2-digit",
                month: "2-digit",
                year: "numeric",
              })}{" "}
              / <span className="font-semibold">Prof:</span>{" "}
              {evolucao.profissional?.nmProfissional || "Vazio"}
            </span>
            <FaEye className="text-blue-600 w-4 h-4" />
          </div>
        )}
      </div>
    );
  };

  const getEspecialidadeDaEvolucao = (evolucao: Evolucao) =>
    evolucao.profissional?.especialidade?.dsEspecialidade?.trim() ||
    "Sem Especialidade";

  const groupByEspecialidade = (evolucoes: Evolucao[]) => {
    const agrupado = evolucoes.reduce(
      (acc, evolucao) => {
        const especialidade = getEspecialidadeDaEvolucao(evolucao);
        if (!acc[especialidade]) {
          acc[especialidade] = [];
        }
        acc[especialidade].push(evolucao);
        return acc;
      },
      {} as Record<string, Evolucao[]>,
    );

    const ordenado: Record<string, Evolucao[]> = {};
    Object.keys(agrupado)
      .sort((a, b) => a.localeCompare(b))
      .forEach((especialidade) => {
        ordenado[especialidade] = agrupado[especialidade];
      });

    return ordenado;
  };

  const renderAtendimentos = () => {
    const groupedAtendimentos = groupByEspecialidade(outrosProfissionais);
    const groups = Object.entries(groupedAtendimentos).map(
      ([especialidade, items]) => {
        const profissionaisMap: Record<
          number,
          {
            idProfissional: number;
            nome: string;
            items: Evolucao[];
          }
        > = {};

        items.forEach((item) => {
          const idProfissional = Number(item.idProfissional);
          if (!profissionaisMap[idProfissional]) {
            profissionaisMap[idProfissional] = {
              idProfissional,
              nome: item.profissional?.nmProfissional || "Sem nome",
              items: [],
            };
          }
          profissionaisMap[idProfissional].items.push(item);
        });

        return {
          especialidade,
          profissionais: Object.values(profissionaisMap).sort((a, b) =>
            a.nome.localeCompare(b.nome, "pt-BR"),
          ),
        };
      },
    );

    return (
      <GroupedProfessionalsAccordion
        groups={groups}
        expandedEspecialidades={expandedEspecialidades}
        expandedProfissionais={expandedProfissionais}
        currentPages={outrosCurrentPages}
        itemsPerPage={outrosItensPorPagina}
        density="compact"
        onToggleEspecialidade={toggleEspecialidade}
        onToggleProfissional={toggleProfissional}
        onPageChange={(profissionalId, page) =>
          setOutrosCurrentPages((prev) => ({
            ...prev,
            [profissionalId]: page,
          }))
        }
        renderItem={renderEvolucao}
      />
    );
  };

  const formatDate = (dateStr: string) => {
    const [year, month, day] = dateStr.split("-");
    return `${day}/${month}/${year}`;
  };

  const openModalEsp = () => {
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  useEffect(() => {
    const fetchData = async () => {
      const cpf = Cookies.get("NuCPF");
      const token = sessionStorage.getItem("token");
      const meuIdProfissional = Number(Cookies.get("idProfissional"));

      try {
        const { data } = await api.get<Evolucao[]>(
          `/sisclinic/prontuarios/cpf/${cpf}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          },
        );

        const meus = data
          .filter((e) => e.idProfissional === meuIdProfissional)
          .sort(
            (a, b) =>
              new Date(b.dtHraEvolucao).getTime() -
              new Date(a.dtHraEvolucao).getTime(),
          );

        const outros = data
          .filter((e) => e.idProfissional !== meuIdProfissional)
          .sort(
            (a, b) =>
              new Date(b.dtHraEvolucao).getTime() -
              new Date(a.dtHraEvolucao).getTime(),
          );

        const profissionaisIds = [
          ...new Set(
            outros
              .map((e) =>
                Number(e.idProfissional || e.profissional?.idProfissional),
              )
              .filter((id) => Number.isFinite(id) && id > 0),
          ),
        ];
        const especialidadesMap = await buscarEspecialidadesProfissionais(
          profissionaisIds,
          token,
        );

        const outrosComEspecialidade = outros.map((evolucao) => {
          const profissionalId = Number(
            evolucao.idProfissional || evolucao.profissional?.idProfissional,
          );

          return {
            ...evolucao,
            idProfissional:
              (Number.isFinite(profissionalId) && profissionalId > 0
                ? profissionalId
                : evolucao.idProfissional) || 0,
            profissional: {
              ...evolucao.profissional,
              especialidade: {
                ...evolucao.profissional?.especialidade,
                dsEspecialidade:
                  especialidadesMap[profissionalId] ||
                  evolucao.profissional?.especialidade?.dsEspecialidade ||
                  "Sem Especialidade",
              },
            },
          };
        });

        setMeusAtendimentos(meus);
        setOutrosProfissionais(outrosComEspecialidade);
        setOutrosCurrentPages({});
        const hoje = new Date().toISOString().split("T")[0];
        const cdPacienteAtual = Number(Cookies.get("cdPaciente"));
        const prontuarioAtualDoDia = meus.find((evolucao) => {
          const dataEvolucao = evolucao.dtHraEvolucao?.split("T")[0];
          return (
            dataEvolucao === hoje &&
            Number(evolucao.cdPaciente) === cdPacienteAtual
          );
        });
        setProntuarioAtualId(prontuarioAtualDoDia?.idEvolucao || null);
        setProntuarioAnexosId(prontuarioAtualDoDia?.idEvolucao || null);
      } catch (error) {
        console.error("Erro ao buscar os prontuÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¡rios:", error);
      }
    };

    fetchData();
  }, []);

  useEffect(() => {
    const hoje = new Date();
    const dataEvolucao = hoje.toISOString().split("T")[0];

    const token = sessionStorage.getItem("token");

    const fetchProntuario = async () => {
      try {
        const response = await api.get("/sisclinic/prontuarios/visualizar", {
          params: {
            idEvent,
            nome,
            cdPaciente,
            idProfissional,
            dataEvolucao,
          },
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        const idProntuarioVisualizado = Number(
          response.data?.idEvolucao ??
            response.data?.prontuario?.idEvolucao ??
            response.data?.id ??
            0,
        );

        if (idProntuarioVisualizado > 0) {
          setProntuarioAtualId(idProntuarioVisualizado);
          setProntuarioAnexosId(idProntuarioVisualizado);
        }
        setDados(response.data);
      } catch (error) {}
    };

    if (idEvent && nome && cdPaciente && idProfissional) {
      fetchProntuario();
    }
  }, [idEvent, nome, cdPaciente, idProfissional]);

  useEffect(() => {
    const token = sessionStorage.getItem("token");

    if (token) {
      api
        .get("/profissionais", {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        })
        .then((res) => setProfissionais(res.data))
        .catch((err) => console.error("Erro ao buscar profissionais:", err));
    }
  }, []);

  useEffect(() => {
    setTimeout(() => {
      setLoadingMeus(false);
      setLoadingOutros(false);
    }, 1500);
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      if (!isOpen) return;

      const cdPaciente = Cookies.get("cdPaciente");
      const token = sessionStorage.getItem("token");

      if (cdPaciente && token) {
        try {
          const response = await api.get(
            `/sisclinic/mais-saude/paciente/${cdPaciente}`,
            {
              headers: {
                "Cache-Control": "no-cache",
                Authorization: `Bearer ${token}`,
              },
            },
          );

          const data = response.data;

          if (Array.isArray(data)) {
            setCiclos(data);
          } else if (data && Array.isArray(data.ciclos)) {
            setCiclos(data.ciclos);
          } else {
            console.warn("Formato inesperado de resposta da API:", data);
          }
        } catch (err) {
          console.error("Erro ao buscar ciclos:", err);
        }
      } else {
        console.error("cdPaciente ou token nÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â£o encontrado");
      }
    };

    fetchData();
  }, [isOpen]);

  useEffect(() => {
    const fetchEspecialidades = async () => {
      try {
        const response = await api.get("/sisclinic/especialidades");
        setEspecialidades(response.data);
      } catch (error) {
        console.error("Erro ao buscar especialidades:", error);
      }
    };

    fetchEspecialidades();
  }, []);

  useEffect(() => {
    if (meusAtendimentos.length > 0) {
      const evolucoesDoProfissional = meusAtendimentos.filter(
        (evo) => evo.idProfissional === Number(Cookies.get("idProfissional")),
      );

      const ultimo = evolucoesDoProfissional.sort(
        (a, b) =>
          new Date(b.dtHraEvolucao).getTime() -
          new Date(a.dtHraEvolucao).getTime(),
      )[0];

      if (ultimo) {
        setProntuarioAtual(ultimo.dsEvolucao);
        setEvolucaoEditando(ultimo);
      }
    }
  }, [meusAtendimentos]);

  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.key === "Escape") {
        setModalAberto(false);
        setModalAberto2(false);
        setProntuarioAtual("");
      }
    };

    window.addEventListener("keydown", handleKeyDown);

    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, []);

  useEffect(() => {
    const atendimentoConcluido = Cookies.get("atendimentoConcluido");
    if (atendimentoConcluido === "true") {
      navigate("/RecordEdite", { replace: true });
    }
  }, [navigate]);

  useEffect(() => {
    const atendimentoNutricionistaConcluido = Cookies.get(
      "atendimentoNutricionistaConcluido",
    );
    if (atendimentoNutricionistaConcluido === "true") {
      navigate("/medico/atendimentonutricionista", { replace: true });
    }
  }, [navigate]);

  return (
    <>
      <Menu
        onSelectMenu={function (path: string): void {
          throw new Error("Function not implemented.");
        }}
      />
      <div className="p-4 sm:p-6 md:p-4 bg-gradient-to-tr from-gray-50 to-gray-100 min-h-[85vh] space-y-6 sm:space-y-3">
        {/* Menu Superior */}
        <div className="flex flex-col lg:flex-row lg:justify-between lg:items-center p-4 rounded-2xl border-gray-200 gap-4">
          {/* Filtro e botÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â£o de status */}
          <div className="flex flex-col sm:flex-row sm:items-center gap-4 flex-1 min-w-0">
            <div className="flex flex-wrap gap-2 w-full text-xs items-center">
              {/* BotÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â£o de status */}
              {flPms === "1" && (
                <button
                  onClick={() => setIsOpen(true)}
                  className="bg-gray-200 hover:bg-gray-300 px-4 py-2 rounded-lg transition w-full sm:w-auto"
                >
                  {"Status paciente + sa\u00FAde"}
                </button>
              )}

              {/* Renderiza documentos */}
              <RenderDocumentos />

              {/* BotÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â£o Voltar sempre ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â  direita */}
              <div className="ml-auto">
                <button
                  onClick={() => navigate("/Sad_Formulario")}
                  className="bg-red-600 hover:bg-red-500 text-white font-semibold py-2 px-4 rounded"
                >
                  Voltar
                </button>
              </div>
            </div>
          </div>

          {/* Modal centralizado */}
          {isOpen && (
            <div className="fixed inset-0 flex items-center justify-center z-50 bg-black bg-opacity-40">
              <div className="bg-white rounded-xl shadow-lg w-full max-w-4xl p-6 relative overflow-auto max-h-[90vh]">
                <button
                  onClick={() => setIsOpen(false)}
                  className="absolute top-2 right-3 text-gray-500 hover:text-red-500 text-xl"
                >
                  ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¯ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¿ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â½-
                </button>

                <h2 className="text-xl font-bold mb-4 flex justify-between items-center">
                  Ciclos do Paciente
                  <button
                    onClick={atualizar}
                    className="bg-blue-500 hover:bg-blue-700 text-white px-3 py-1 rounded-lg transition w-full sm:w-auto flex items-center justify-center text-sm"
                  >
                    <FaSyncAlt className="h-4 w-4 mr-2" />
                    Atualizar
                  </button>
                  <button
                    onClick={openModalEsp}
                    className="bg-red-500 hover:bg-red-700 text-white px-4 py-2 rounded-lg transition w-full sm:w-auto mr-5"
                  >
                    + Ciclos
                  </button>
                </h2>
                {/* Modal com o select */}
                {isModalOpen && (
                  <div className="fixed inset-0 bg-gray-600 bg-opacity-50 flex justify-end items-stretch">
                    <div className="bg-white p-6 rounded-lg w-96 max-w-full h-full">
                      <h3 className="text-lg font-semibold mb-2">
                        Data de InÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â­cio
                      </h3>
                      <input
                        type="date"
                        value={dtInicio}
                        onChange={handleDtInicioChange}
                        className="w-full p-2 border border-gray-300 rounded-lg mb-4"
                      />
                      <h3 className="text-lg font-semibold mb-2">
                        Data de Fim
                      </h3>
                      <input
                        type="date"
                        value={dtFim}
                        onChange={(e) => setDtFim(e.target.value)}
                        className="w-full p-2 border border-gray-300 rounded-lg mb-4"
                        disabled
                      />
                      <h2 className="text-xl font-bold mb-4">
                        Selecione uma Especialidade
                      </h2>
                      <select
                        value={idEspecialidade}
                        onChange={(e) => setIdEspecialidade(e.target.value)}
                        className="w-full p-2 border border-gray-300 rounded-lg mb-2"
                      >
                        {especialidades.map((especialidade) => (
                          <option
                            key={especialidade.idEspecialidade}
                            value={especialidade.idEspecialidade}
                          >
                            {especialidade.dsEspecialidade}
                          </option>
                        ))}
                      </select>
                      <h3 className="text-lg font-semibold mb-2">Status</h3>
                      <select
                        value={status}
                        onChange={(e) => setStatus(e.target.value)}
                        className={`w-full p-2 border rounded-lg mb-4 ${
                          status === "" ? "border-red-500" : "border-gray-300"
                        }`}
                      >
                        <option value="">SELECIONE</option>
                        <option value="EM_ANDAMENTO">EM ANDAMENTO</option>
                        <option value="PENDENTE">PENDENTE</option>
                        <option value="CONCLUIDO">CONCLUÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚ÂDO</option>
                        <option value="RETORNO">RETORNO</option>
                        <option value="CANCELADO">CANCELADO</option>
                      </select>
                      <div className="mt-4 flex justify-end">
                        <button
                          onClick={handleSubmit}
                          className="bg-green-500 hover:bg-green-600 text-white px-4 py-2 rounded-lg mr-2"
                        >
                          Enviar
                        </button>

                        <button
                          onClick={closeModal}
                          className="bg-red-500 hover:bg-red-600 text-white px-4 py-2 rounded-lg"
                        >
                          Fechar
                        </button>
                      </div>
                    </div>
                  </div>
                )}

                <table className="w-full table-auto border border-gray-300">
                  <thead className="bg-gray-100">
                    <tr>
                      <th className="px-4 py-2 border">Especialidade</th>
                      <th className="px-4 py-2 border">Data InÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â­cio</th>
                      <th className="px-4 py-2 border">Data Fim</th>
                      <th className="px-4 py-2 border">Status</th>
                    </tr>
                  </thead>
                  <tbody>
                    {paginatedCiclos.length === 0 ? (
                      <tr>
                        <td colSpan={4} className="text-center py-4">
                          Nenhum ciclo encontrado.
                        </td>
                      </tr>
                    ) : (
                      paginatedCiclos.map((item) => (
                        <tr key={item.id} className="text-center">
                          <td className="px-4 py-2 border">
                            {item.especialidade.dsEspecialidade}
                          </td>
                          <td className="px-4 py-2 border">
                            {formatDate(item.dtInicio)}
                          </td>
                          <td className="px-4 py-2 border">
                            {formatDate(item.dtFim)}
                          </td>
                          <td className="px-4 py-2 border">
                            {item.status.replace(/_/g, " ")}
                          </td>{" "}
                        </tr>
                      ))
                    )}
                  </tbody>
                </table>

                {ciclos.length > 7 && (
                  <div className="flex justify-between mt-4">
                    <button
                      onClick={() => handlePageChange(currentPage - 1)}
                      disabled={currentPage === 1}
                      className="px-4 py-2 bg-gray-300 rounded-lg disabled:opacity-50"
                    >
                      Anterior
                    </button>
                    <span className="self-center">
                      {"P\u00E1gina"} {currentPage} de{" "}
                      {Math.ceil(ciclos.length / itemsPerPage)}
                    </span>
                    <button
                      onClick={() => handlePageChange(currentPage + 1)}
                      disabled={
                        currentPage === Math.ceil(ciclos.length / itemsPerPage)
                      }
                      className="px-4 py-2 bg-gray-300 rounded-lg disabled:opacity-50"
                    >
                      {"Pr\u00F3xima"}
                    </button>
                  </div>
                )}
              </div>
            </div>
          )}
        </div>

        <h1 className="text-1xl sm:text-1xl font-bold text-gray-800 text-center sm:text-left flex items-center gap-2">
          <Stethoscope className="w-6 h-6 ml-2 text-blue-600" />
          Paciente:{" "}
          {nome2
            ? nome2
                .toLowerCase()
                .split(" ")
                .map((p: any) => p.charAt(0).toUpperCase() + p.slice(1))
                .join(" ")
            : ""}{" "}
          - idade {idade}
        </h1>
        {/* ConteÃºdo */}
        <div className="flex flex-col lg:flex-row gap-6">
          {/* Anamnese */}
          <div className="w-full lg:w-2/3 bg-white p-4 md:p-6 rounded-2xl shadow-xl border border-gray-100">
            <h2 className="flex items-center justify-between gap-2 text-xl font-semibold text-gray-500 mb-2">
              <span className="flex items-center gap-2">
                <NotebookPen className="w-5 h-5 text-green-600" />
                {"Prontu\u00E1rio"}
              </span>
              <ProntuarioAnexos
                variant="button"
                prontuarioId={prontuarioAtualId}
                refreshKey={anexosRefreshKey}
                onUploadSuccess={() =>
                  setAnexosRefreshKey((prev) => prev + 1)
                }
              />
            </h2>{" "}
            {modalAberto && (
              <>
                {activeTab === "meus" ? (
                  <div
                    className="fixed inset-0 bg-black bg-opacity-40 z-[9999] flex items-center justify-center"
                    onClick={() => setModalAberto(false)}
                  >
                    <div
                      className="bg-white rounded-2xl shadow-xl p-6 w-full max-w-4xl max-h-[90%] flex flex-col overflow-hidden"
                      onClick={(e) => e.stopPropagation()}
                    >
                      <div className="flex items-center justify-between mb-4">
                        <h2 className="text-2xl font-bold flex items-center gap-2 text-gray-800">
                          <FaFileMedicalAlt className="text-blue-600" />
                          Meus Atendimentos
                        </h2>
                        <button
                          onClick={() => setModalAberto(false)}
                          className="text-sm px-3 py-1 bg-red-600 text-white rounded hover:bg-red-700 transition"
                        >
                          Fechar
                        </button>
                      </div>

                      <div className="flex-1 overflow-y-auto space-y-4 pr-2">
                        {loadingMeus ? (
                          <p className="text-center text-gray-500 italic animate-pulse">
                            Carregando atendimentos...
                          </p>
                        ) : meusAtendimentos.length > 0 ? (
                          meusAtendimentos
                            .slice(
                              (paginaAtual - 1) * itensPorPagina,
                              paginaAtual * itensPorPagina,
                            )
                            .map((evolucao, idxGlobal) => {
                              const idx =
                                (paginaAtual - 1) * itensPorPagina + idxGlobal;
                              const isAberto = prontuarioIndexAberto === idx;

                              const dataAtendimento = new Date(
                                evolucao.dtHraEvolucao,
                              );

                              return (
                                <div
                                  key={idx}
                                  className="border border-gray-200 rounded-xl bg-gray-50 shadow-sm"
                                >
                                  <div
                                    className="cursor-pointer px-4 py-3 hover:bg-gray-100 transition flex justify-between items-center"
                                    onClick={() =>
                                      setProntuarioIndexAberto((prev) =>
                                        prev === idx ? null : idx,
                                      )
                                    }
                                  >
                                    <div className="flex flex-col sm:flex-row sm:gap-6">
                                      <span>
                                        <span className="font-semibold">
                                          Data:
                                        </span>{" "}
                                        {dataAtendimento.toLocaleDateString(
                                          "pt-BR",
                                          {
                                            day: "2-digit",
                                            month: "2-digit",
                                            year: "numeric",
                                          },
                                        )}
                                      </span>
                                    </div>
                                    <span className="text-blue-600 text-xl">
                                      {isAberto ? "-" : "+"}
                                    </span>
                                  </div>

                                  {isAberto && (
                                    <div className="p-4 bg-white border-t space-y-2 text-sm text-gray-900">
                                      <div className="flex justify-end">
                                        <button
                                          onClick={async () => {
                                            try {
                                              await navigator.clipboard.write([
                                                new ClipboardItem({
                                                  "text/html": new Blob(
                                                    [evolucao.dsEvolucao || ""],
                                                    { type: "text/html" },
                                                  ),
                                                  "text/plain": new Blob(
                                                    [evolucao.dsEvolucao || ""],
                                                    { type: "text/plain" },
                                                  ),
                                                }),
                                              ]);

                                              Swal.fire({
                                                icon: "success",
                                                title: "Copiado!",
                                                text: "Texto do atendimento copiado para a ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¡rea de transferÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Âªncia.",
                                                timer: 2000,
                                                showConfirmButton: false,
                                              });
                                            } catch (error) {
                                              Swal.fire({
                                                icon: "error",
                                                title: "Erro!",
                                                text: "NÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â£o foi possÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â­vel copiar o texto.",
                                              });
                                            }
                                          }}
                                          className="px-3 py-1 bg-blue-600 text-white text-xs rounded hover:bg-blue-700 transition"
                                        >
                                          Copiar texto
                                        </button>
                                      </div>

                                      <div
                                        className="whitespace-pre-wrap"
                                        dangerouslySetInnerHTML={{
                                          __html: evolucao.dsEvolucao || "",
                                        }}
                                      />
                                    </div>
                                  )}
                                </div>
                              );
                            })
                        ) : (
                          <p className="text-center text-gray-500 italic">
                            Nenhum atendimento encontrado.
                          </p>
                        )}
                      </div>

                      {/* PaginaÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â§ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â£o */}
                      {meusAtendimentos.length > itensPorPagina && (
                        <div className="flex justify-center mt-4 gap-2">
                          <button
                            onClick={() => mudarPagina(paginaAtual - 1)}
                            disabled={paginaAtual === 1}
                            className="px-3 py-1 bg-gray-300 rounded disabled:opacity-50"
                          >
                            Anterior
                          </button>

                          {[...Array(totalPaginas)].map((_, i) => (
                            <button
                              key={i}
                              onClick={() => mudarPagina(i + 1)}
                              className={`px-3 py-1 rounded ${
                                paginaAtual === i + 1
                                  ? "bg-blue-600 text-white"
                                  : "bg-gray-200"
                              }`}
                            >
                              {i + 1}
                            </button>
                          ))}

                          <button
                            onClick={() => mudarPagina(paginaAtual + 1)}
                            disabled={paginaAtual === totalPaginas}
                            className="px-3 py-1 bg-gray-300 rounded disabled:opacity-50"
                          >
                            {"Pr\u00F3xima"}
                          </button>
                        </div>
                      )}
                    </div>
                  </div>
                ) : (
                  // Modal de outras abas
                  <div className="fixed inset-0 bg-black bg-opacity-40 flex justify-center items-center z-[9999]">
                    <div className="bg-white rounded-xl p-6 shadow-lg w-[95%] h-[90%] flex flex-col overflow-hidden">
                      <h2 className="text-xl font-semibold mb-2">{"Prontu\u00E1rio"}</h2>

                      {activeTab !== "outros" && (
                        <div className="flex justify-end mb-2">
                          <button
                            onClick={async () => {
                              try {
                                await navigator.clipboard.write([
                                  new ClipboardItem({
                                    "text/html": new Blob(
                                      [prontuarioAtual || ""],
                                      {
                                        type: "text/html",
                                      },
                                    ),
                                    "text/plain": new Blob(
                                      [prontuarioAtual || ""],
                                      {
                                        type: "text/plain",
                                      },
                                    ),
                                  }),
                                ]);

                                Swal.fire({
                                  icon: "success",
                                  title: "Copiado!",
                                  text: "Texto com formataÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â§ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â£o copiado para a ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¡rea de transferÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Âªncia.",
                                  timer: 2000,
                                  showConfirmButton: false,
                                });
                              } catch (error) {
                                Swal.fire({
                                  icon: "error",
                                  title: "Erro!",
                                  text: "NÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â£o foi possÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â­vel copiar o texto formatado.",
                                });
                              }
                            }}
                            className="px-3 py-1 bg-red-800 text-white text-xs rounded hover:bg-red-700 transition z-50"
                          >
                            Copiar texto
                          </button>
                        </div>
                      )}

                      {evolucaoEditando && (
                        <div className="mb-4 text-sm text-gray-700 space-y-1">
                          <p>
                            <span className="font-semibold">Data:</span>{" "}
                            {new Date(
                              evolucaoEditando.dtHraEvolucao,
                            ).toLocaleDateString("pt-BR", {
                              day: "2-digit",
                              month: "2-digit",
                              year: "numeric",
                            })}{" "}
                          </p>
                          <p>
                            <span className="font-semibold">Prof:</span>{" "}
                            {evolucaoEditando.profissional?.nmProfissional ||
                              "Desconhecido"}
                          </p>
                        </div>
                      )}

                      <div className="flex-1 border rounded p-3 overflow-y-auto whitespace-pre-wrap">
                        <div
                          dangerouslySetInnerHTML={{ __html: prontuarioAtual }}
                        />
                      </div>

                      <div className="mt-4 flex justify-end gap-2">
                        <button
                          onClick={() => setModalAberto(false)}
                          className="px-4 py-2 bg-gray-800 text-white rounded hover:bg-gray-700 hover:text-white"
                        >
                          Fechar
                        </button>
                      </div>
                    </div>
                  </div>
                )}
              </>
            )}{" "}
            {modalAberto2 && (
              <>
                {activeTab === "meus" ? (
                  <div
                    className="fixed inset-0 bg-black bg-opacity-40 z-[9999] flex items-center justify-center"
                    onClick={() => setModalAberto(false)}
                  >
                    <div
                      className="bg-white rounded-2xl shadow-xl p-6 w-full max-w-4xl max-h-[90%] flex flex-col overflow-hidden"
                      onClick={(e) => e.stopPropagation()}
                    >
                      <div className="flex items-center justify-between mb-4">
                        <h2 className="text-2xl font-bold flex items-center gap-2 text-gray-800">
                          <FaFileMedicalAlt className="text-blue-600" />
                          Meus Atendimentos
                        </h2>
                        <button
                          onClick={() => setModalAberto(false)}
                          className="text-sm px-3 py-1 bg-red-600 text-white rounded hover:bg-red-700 transition"
                        >
                          Fechar
                        </button>
                      </div>

                      <div className="flex-1 overflow-y-auto space-y-4 pr-2">
                        {loadingMeus ? (
                          <p className="text-center text-gray-500 italic animate-pulse">
                            Carregando atendimentos...
                          </p>
                        ) : meusAtendimentos.length > 0 ? (
                          meusAtendimentos
                            .slice(
                              (paginaAtual - 1) * itensPorPagina,
                              paginaAtual * itensPorPagina,
                            )
                            .map((evolucao, idxGlobal) => {
                              const idx =
                                (paginaAtual - 1) * itensPorPagina + idxGlobal;
                              const isAberto = prontuarioIndexAberto === idx;

                              const dataAtendimento = new Date(
                                evolucao.dtHraEvolucao,
                              );

                              return (
                                <div
                                  key={idx}
                                  className="border border-gray-200 rounded-xl bg-gray-50 shadow-sm"
                                >
                                  <div
                                    className="cursor-pointer px-4 py-3 hover:bg-gray-100 transition flex justify-between items-center"
                                    onClick={() =>
                                      setProntuarioIndexAberto((prev) =>
                                        prev === idx ? null : idx,
                                      )
                                    }
                                  >
                                    <div className="flex flex-col sm:flex-row sm:gap-6">
                                      <span>
                                        <span className="font-semibold">
                                          Data:
                                        </span>{" "}
                                        {dataAtendimento.toLocaleDateString(
                                          "pt-BR",
                                          {
                                            day: "2-digit",
                                            month: "2-digit",
                                            year: "numeric",
                                          },
                                        )}
                                      </span>
                                    </div>
                                    <span className="text-blue-600 text-xl">
                                      {isAberto ? "-" : "+"}
                                    </span>
                                  </div>

                                  {isAberto && (
                                    <div className="p-4 bg-white border-t space-y-2 text-sm text-gray-900">
                                      <div className="flex justify-end">
                                        <button
                                          onClick={async () => {
                                            try {
                                              await navigator.clipboard.write([
                                                new ClipboardItem({
                                                  "text/html": new Blob(
                                                    [evolucao.dsEvolucao || ""],
                                                    { type: "text/html" },
                                                  ),
                                                  "text/plain": new Blob(
                                                    [evolucao.dsEvolucao || ""],
                                                    { type: "text/plain" },
                                                  ),
                                                }),
                                              ]);

                                              Swal.fire({
                                                icon: "success",
                                                title: "Copiado!",
                                                text: "Texto do atendimento copiado para a ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¡rea de transferÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Âªncia.",
                                                timer: 2000,
                                                showConfirmButton: false,
                                              });
                                            } catch (error) {
                                              Swal.fire({
                                                icon: "error",
                                                title: "Erro!",
                                                text: "NÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â£o foi possÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â­vel copiar o texto.",
                                              });
                                            }
                                          }}
                                          className="px-3 py-1 bg-blue-600 text-white text-xs rounded hover:bg-blue-700 transition"
                                        >
                                          Copiar texto
                                        </button>
                                      </div>

                                      <div
                                        className="whitespace-pre-wrap"
                                        dangerouslySetInnerHTML={{
                                          __html: evolucao.dsEvolucao || "",
                                        }}
                                      />
                                    </div>
                                  )}
                                </div>
                              );
                            })
                        ) : (
                          <p className="text-center text-gray-500 italic">
                            Nenhum atendimento encontrado.
                          </p>
                        )}
                      </div>

                      {/* PaginaÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â§ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â£o */}
                      {meusAtendimentos.length > itensPorPagina && (
                        <div className="flex justify-center mt-4 gap-2">
                          <button
                            onClick={() => mudarPagina(paginaAtual - 1)}
                            disabled={paginaAtual === 1}
                            className="px-3 py-1 bg-gray-300 rounded disabled:opacity-50"
                          >
                            Anterior
                          </button>

                          {[...Array(totalPaginas)].map((_, i) => (
                            <button
                              key={i}
                              onClick={() => mudarPagina(i + 1)}
                              className={`px-3 py-1 rounded ${
                                paginaAtual === i + 1
                                  ? "bg-blue-600 text-white"
                                  : "bg-gray-200"
                              }`}
                            >
                              {i + 1}
                            </button>
                          ))}

                          <button
                            onClick={() => mudarPagina(paginaAtual + 1)}
                            disabled={paginaAtual === totalPaginas}
                            className="px-3 py-1 bg-gray-300 rounded disabled:opacity-50"
                          >
                            {"Pr\u00F3xima"}
                          </button>
                        </div>
                      )}
                    </div>
                  </div>
                ) : (
                  // Modal de outras abas
                  <div className="fixed inset-0 bg-black bg-opacity-40 flex justify-center items-center z-[9999]">
                    <div className="bg-white rounded-xl p-6 shadow-lg w-[95%] h-[90%] flex flex-col overflow-hidden">
                      <h2 className="text-xl font-semibold mb-2">{"Prontu\u00E1rio"}</h2>
                      {activeTab !== "outros" && (
                        <div className="flex justify-end mb-2">
                          <button
                            onClick={async () => {
                              try {
                                await navigator.clipboard.write([
                                  new ClipboardItem({
                                    "text/html": new Blob(
                                      [prontuarioAtual || ""],
                                      {
                                        type: "text/html",
                                      },
                                    ),
                                    "text/plain": new Blob(
                                      [prontuarioAtual || ""],
                                      {
                                        type: "text/plain",
                                      },
                                    ),
                                  }),
                                ]);

                                Swal.fire({
                                  icon: "success",
                                  title: "Copiado!",
                                  text: "Texto com formataÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â§ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â£o copiado para a ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¡rea de transferÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Âªncia.",
                                  timer: 2000,
                                  showConfirmButton: false,
                                });
                              } catch (error) {
                                Swal.fire({
                                  icon: "error",
                                  title: "Erro!",
                                  text: "NÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â£o foi possÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â­vel copiar o texto formatado.",
                                });
                              }
                            }}
                            className="px-3 py-1 bg-red-800 text-white text-xs rounded hover:bg-red-700 transition z-50"
                          >
                            Copiar texto
                          </button>
                        </div>
                      )}

                      {evolucaoEditando && (
                        <div className="mb-4 text-sm text-gray-700 space-y-1">
                          <p>
                            <span className="font-semibold">Data:</span>{" "}
                            {new Date(
                              evolucaoEditando.dtHraEvolucao,
                            ).toLocaleDateString("pt-BR", {
                              day: "2-digit",
                              month: "2-digit",
                              year: "numeric",
                            })}{" "}
                          </p>
                          <p>
                            <span className="font-semibold">Prof:</span>{" "}
                            {evolucaoEditando.profissional?.nmProfissional ||
                              "Desconhecido"}
                          </p>
                        </div>
                      )}

                      <div className="flex-1 border rounded p-3 overflow-y-auto whitespace-pre-wrap">
                        <div
                          dangerouslySetInnerHTML={{ __html: prontuarioAtual }}
                        />
                      </div>

                      <div className="mt-4 flex justify-end gap-2">
                        <button
                          onClick={() => {
                            setModalAberto2(false); // fecha o modal
                            setProntuarioAtual(""); // limpa o conteÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Âºdo do prontuÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¡rio
                          }}
                          className="px-4 py-2 bg-gray-800 text-white rounded hover:bg-gray-700 hover:text-white"
                        >
                          Fechar
                        </button>
                      </div>
                    </div>
                  </div>
                )}
              </>
            )}
            <>
              {/* SÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â³ exibe o ReactQuill se o modal nÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â£o estiver aberto */}
              {!modalAberto && (
                <>
                  <ReactQuill
                    value={prontuarioAtual}
                    onChange={handleChange}
                    modules={{
                      toolbar: [
                        [{ font: [] }],
                        [{ size: ["small", "medium", "large", "huge"] }],
                        [{ list: "ordered" }, { list: "bullet" }],
                        ["bold", "italic", "underline"],
                        ["link", "image"],
                        [{ align: [] }],
                        [
                          { color: ["#000000", "#e60000", "#0000ff", "#ffff"] },
                          { background: ["#ffff00"] },
                        ],
                        ["blockquote"],
                      ],
                    }}
                    style={{ height: "20rem", marginBottom: "2.7rem" }}
                  />

                  <p className="text-sm text-gray-500 break-words">
                    {(prontuarioAtual || "").length}/{LIMITE_CARACTERES}{" "}
                    caracteres
                  </p>
                </>
              )}{" "}
              {modalAberto && (
                <>
                  <ReactQuill
                    onChange={handleChange}
                    modules={{
                      toolbar: [
                        [{ font: [] }],
                        [{ size: ["small", "medium", "large", "huge"] }],
                        [{ list: "ordered" }, { list: "bullet" }],
                        ["bold", "italic", "underline"],
                        ["link", "image"],
                        [{ align: [] }],
                        [
                          { color: ["#000000", "#e60000", "#0000ff"] },
                          { background: ["#ffff00"] },
                        ],
                        ["blockquote"],
                      ],
                    }}
                    style={{ height: "20rem", marginBottom: "2.7rem" }}
                  />

                  <p className="text-sm text-gray-500 break-words">
                    {(prontuarioAtual || "").length}/{LIMITE_CARACTERES}{" "}
                    caracteres
                  </p>
                </>
              )}
            </>
            <div className="mt-6 flex flex-wrap gap-4">
              <button
                className={`${
                  salvando ? "bg-green-400" : "bg-green-600 hover:bg-green-700"
                } text-white px-6 py-2 rounded-lg shadow transition w-full sm:w-auto flex items-center justify-center`}
                onClick={salvarProntuario}
                disabled={salvando}
              >
                {salvando ? (
                  <>
                    <FaSave className="animate-spin mr-2" /> Salvando...
                  </>
                ) : (
                  <>
                    <FaSave className="mr-2" />
                    {!modoEdicao
                      ? "Atualizar Prontu\u00E1rio"
                      : "Atualizar Prontu\u00E1rio"}
                  </>
                )}
              </button>
            </div>
          </div>

          <div className="w-full lg:w-1/3 space-y-8">
            {/* Meus Atendimentos */}
            <div className="bg-white p-4 md:p-6 rounded-2xl shadow-xl border border-gray-100">
              <button
                onClick={() => {
                  toggleTab("meus");
                }}
                className="w-full text-left text-base sm:text-sm font-bold text-red-600 border-b border-gray-200 pb-3 mb-4 flex items-center justify-between"
              >
                <span className="flex items-center gap-2">
                  <Stethoscope className="mr-2" /> Meus Atendimentos
                </span>
                <ChevronRight
                  className={`w-4 h-4 transition-transform duration-300 ${
                    activeTab === "meus" ? "rotate-90" : "rotate-0"
                  }`}
                />
              </button>

              {activeTab === "meus" && (
                <>
                  {loadingMeus ? (
                    <p className="text-sm text-gray-500 italic text-center animate-pulse">
                      Carregando atendimentos...
                    </p>
                  ) : (
                    <>
                      {meusAtendimentos.length > 0 ? (
                        <ul className="list-disc pl-4 space-y-2">
                          {meusAtendimentos
                            .sort(
                              (a, b) =>
                                new Date(b.dtHraEvolucao).getTime() -
                                new Date(a.dtHraEvolucao).getTime(),
                            )
                            .slice(0, 10)
                            .map(renderEvolucao)}
                        </ul>
                      ) : (
                        <p className="text-sm text-gray-500 italic text-center">
                          Nenhum atendimento encontrado.
                        </p>
                      )}
                    </>
                  )}
                </>
              )}
            </div>

            <div className="bg-white p-4 md:p-6 rounded-2xl shadow-xl border border-gray-100">
              <button
                onClick={() => toggleTab("altas")}
                className="w-full text-left text-base sm:text-sm font-bold text-black-600 border-b border-gray-200 pb-3 mb-4 flex items-center justify-between"
              >
                <span className="flex items-center gap-2">
                  <FileText className="mr-0" /> Altas - Fisioterapia
                </span>
                <ChevronRight
                  className={`w-4 h-4 transition-transform duration-300 ${
                    activeTab === "altas" ? "rotate-90" : "rotate-0"
                  }`}
                />
              </button>
              {activeTab === "altas" && (
                <>
                  {loadingReceituarios ? (
                    <p className="text-sm text-gray-700 italic text-center animate-pulse">
                      Carregando altas...
                    </p>
                  ) : (
                    <>
                      {receituariosLaudos.filter(
                        (item) => item.tipo === "ALTA_FISIO",
                      ).length > 0 ? (
                        <div className="space-y-4">
                          {loadingGruposAltas ? (
                            <p className="text-sm text-gray-500 italic">
                              Carregando altas...
                            </p>
                          ) : (
                            gruposAltas
                              .sort((a, b) =>
                                a.especialidade.localeCompare(
                                  b.especialidade,
                                  "pt-BR",
                                ),
                              )
                              .map((grupo) => (
                                <div
                                  key={grupo.especialidade}
                                  className="border rounded-lg p-3"
                                >
                                  <div
                                    className="flex justify-between items-center cursor-pointer"
                                    onClick={() =>
                                      toggleEspecialidade(grupo.especialidade)
                                    }
                                  >
                                    <div>
                                      <h4 className="font-bold text-xs text-black-700 uppercase">
                                        {grupo.especialidade}
                                      </h4>
                                    </div>
                                    <span className="text-blue-600 text-xl font-bold">
                                      {expandedEspecialidades.includes(
                                        grupo.especialidade,
                                      )
                                        ? "-"
                                        : "+"}
                                    </span>
                                  </div>

                                  {expandedEspecialidades.includes(
                                    grupo.especialidade,
                                  ) && (
                                    <div className="mt-3 space-y-4">
                                      {grupo.profissionais
                                        .sort((a, b) =>
                                          a.nome.localeCompare(b.nome, "pt-BR"),
                                        )
                                        .map((profissional) => (
                                          <div
                                            key={profissional.idProfissional}
                                            className="ml-4 border-l-2 border-gray-300 pl-3"
                                          >
                                            <div
                                              className="flex justify-between items-center cursor-pointer"
                                              onClick={() =>
                                                toggleProfissional(
                                                  profissional.idProfissional,
                                                  grupo.especialidade,
                                                )
                                              }
                                            >
                                              <h5 className="font-medium text-sm text-gray-500">
                                                {profissional.nome}
                                              </h5>
                                              <span className="text-blue-600 text-xl font-bold">
                                                {expandedProfissionais.includes(
                                                  profissional.idProfissional,
                                                )
                                                  ? "-"
                                                  : "+"}
                                              </span>
                                            </div>

                                            {expandedProfissionais.includes(
                                              profissional.idProfissional,
                                            ) && (
                                              <div className="mt-2 space-y-2">
                                                {profissional.items
                                                  .slice(
                                                    ((currentPages[
                                                      profissional
                                                        .idProfissional
                                                    ] || 1) -
                                                      1) *
                                                      itemsPerPage,
                                                    (currentPages[
                                                      profissional
                                                        .idProfissional
                                                    ] || 1) * itemsPerPage,
                                                  )
                                                  .map(renderReceituarioLaudo)}

                                                {profissional.items.length >
                                                  itemsPerPage && (
                                                  <div className="flex justify-center items-center mt-4 gap-2">
                                                    <button
                                                      onClick={(e) => {
                                                        e.stopPropagation();
                                                        handlePageChange2(
                                                          profissional.idProfissional,
                                                          Math.max(
                                                            (currentPages[
                                                              profissional
                                                                .idProfissional
                                                            ] || 1) - 1,
                                                            1,
                                                          ),
                                                        );
                                                      }}
                                                      disabled={
                                                        (currentPages[
                                                          profissional
                                                            .idProfissional
                                                        ] || 1) === 1
                                                      }
                                                      className="px-3 py-1 bg-gray-200 rounded text-sm disabled:opacity-50"
                                                    >
                                                      Anterior
                                                    </button>

                                                    <span className="text-xs text-gray-600">
                                                      {"P\u00E1gina"}{" "}
                                                      {currentPages[
                                                        profissional
                                                          .idProfissional
                                                      ] || 1}{" "}
                                                      de{" "}
                                                      {Math.ceil(
                                                        profissional.items
                                                          .length /
                                                          itemsPerPage,
                                                      )}
                                                    </span>

                                                    <button
                                                      onClick={(e) => {
                                                        e.stopPropagation();
                                                        handlePageChange2(
                                                          profissional.idProfissional,
                                                          Math.min(
                                                            (currentPages[
                                                              profissional
                                                                .idProfissional
                                                            ] || 1) + 1,
                                                            Math.ceil(
                                                              profissional.items
                                                                .length /
                                                                itemsPerPage,
                                                            ),
                                                          ),
                                                        );
                                                      }}
                                                      disabled={
                                                        (currentPages[
                                                          profissional
                                                            .idProfissional
                                                        ] || 1) ===
                                                        Math.ceil(
                                                          profissional.items
                                                            .length /
                                                            itemsPerPage,
                                                        )
                                                      }
                                                      className="px-3 py-1 bg-gray-200 rounded text-sm disabled:opacity-50"
                                                    >
                                                      {"Pr\u00F3xima"}
                                                    </button>
                                                  </div>
                                                )}
                                              </div>
                                            )}
                                          </div>
                                        ))}
                                    </div>
                                  )}
                                </div>
                              ))
                          )}
                        </div>
                      ) : (
                        <p className="text-sm text-gray-500 italic text-center">
                          Nenhuma alta encontrada.
                        </p>
                      )}
                    </>
                  )}
                </>
              )}
            </div>

            <div className="bg-white p-4 md:p-6 rounded-2xl shadow-xl border border-gray-100">
              <button
                onClick={() => toggleTab("receituarios")}
                className="w-full text-left text-base sm:text-sm font-bold text-black-600 border-b border-gray-200 pb-3 mb-4 flex items-center justify-between"
              >
                <span className="flex items-center gap-2">
                  <FileText className="mr-0" />{"Receitu\u00E1rios, Laudos e Atestados"}
                </span>
                <ChevronRight
                  className={`w-4 h-4 transition-transform duration-300 ${
                    activeTab === "receituarios" ? "rotate-90" : "rotate-0"
                  }`}
                />
              </button>

              {activeTab === "receituarios" && (
                <>
                  {loadingReceituarios ? (
                    <p className="text-sm text-gray-700 italic text-center animate-pulse">
                      {"Carregando receitu\u00E1rios e laudos..."}
                    </p>
                  ) : (
                    <>
                      {receituariosLaudos.filter(
                        (item) => item.tipo !== "ALTA_FISIO",
                      ).length > 0 ? (
                        <div className="space-y-4">
                          {loadingGrupos ? (
                            <p className="text-sm text-gray-500 italic">
                              Carregando grupos...
                            </p>
                          ) : (
                            grupos
                              .sort((a, b) =>
                                a.especialidade.localeCompare(
                                  b.especialidade,
                                  "pt-BR",
                                ),
                              )
                              .map((grupo) => (
                                <div
                                  key={grupo.especialidade}
                                  className="border rounded-lg p-3"
                                >
                                  <div
                                    className="flex justify-between items-center cursor-pointer"
                                    onClick={() =>
                                      toggleEspecialidade(grupo.especialidade)
                                    }
                                  >
                                    <div>
                                      <h4 className="font-bold text-xs text-black-700 uppercase">
                                        {grupo.especialidade}
                                      </h4>
                                    </div>
                                    <span className="text-blue-600 text-xl font-bold">
                                      {expandedEspecialidades.includes(
                                        grupo.especialidade,
                                      )
                                        ? "-"
                                        : "+"}
                                    </span>
                                  </div>

                                  {expandedEspecialidades.includes(
                                    grupo.especialidade,
                                  ) && (
                                    <div className="mt-3 space-y-4">
                                      {grupo.profissionais
                                        .sort((a, b) =>
                                          a.nome.localeCompare(b.nome, "pt-BR"),
                                        )
                                        .map((profissional) => (
                                          <div
                                            key={profissional.idProfissional}
                                            className="ml-4 border-l-2 border-gray-300 pl-3"
                                          >
                                            <div
                                              className="flex justify-between items-center cursor-pointer"
                                              onClick={() =>
                                                toggleProfissional(
                                                  profissional.idProfissional,
                                                  grupo.especialidade,
                                                )
                                              }
                                            >
                                              <h5 className="font-medium text-sm text-gray-500">
                                                {profissional.nome}
                                              </h5>
                                              <span className="text-blue-600 text-xl font-bold">
                                                {expandedProfissionais.includes(
                                                  profissional.idProfissional,
                                                )
                                                  ? "-"
                                                  : "+"}
                                              </span>
                                            </div>

                                            {expandedProfissionais.includes(
                                              profissional.idProfissional,
                                            ) && (
                                              <div className="mt-2 space-y-2">
                                                {profissional.items
                                                  .slice(
                                                    ((currentPages[
                                                      profissional
                                                        .idProfissional
                                                    ] || 1) -
                                                      1) *
                                                      itemsPerPage,
                                                    (currentPages[
                                                      profissional
                                                        .idProfissional
                                                    ] || 1) * itemsPerPage,
                                                  )
                                                  .map(renderReceituarioLaudo)}

                                                {profissional.items.length >
                                                  itemsPerPage && (
                                                  <div className="flex justify-center items-center mt-4 gap-2">
                                                    <button
                                                      onClick={(e) => {
                                                        e.stopPropagation();
                                                        handlePageChange2(
                                                          profissional.idProfissional,
                                                          Math.max(
                                                            (currentPages[
                                                              profissional
                                                                .idProfissional
                                                            ] || 1) - 1,
                                                            1,
                                                          ),
                                                        );
                                                      }}
                                                      disabled={
                                                        (currentPages[
                                                          profissional
                                                            .idProfissional
                                                        ] || 1) === 1
                                                      }
                                                      className="px-3 py-1 bg-gray-200 rounded text-sm disabled:opacity-50"
                                                    >
                                                      Anterior
                                                    </button>

                                                    <span className="text-xs text-gray-600">
                                                      {"P\u00E1gina"}{" "}
                                                      {currentPages[
                                                        profissional
                                                          .idProfissional
                                                      ] || 1}{" "}
                                                      de{" "}
                                                      {Math.ceil(
                                                        profissional.items
                                                          .length /
                                                          itemsPerPage,
                                                      )}
                                                    </span>

                                                    <button
                                                      onClick={(e) => {
                                                        e.stopPropagation();
                                                        handlePageChange2(
                                                          profissional.idProfissional,
                                                          Math.min(
                                                            (currentPages[
                                                              profissional
                                                                .idProfissional
                                                            ] || 1) + 1,
                                                            Math.ceil(
                                                              profissional.items
                                                                .length /
                                                                itemsPerPage,
                                                            ),
                                                          ),
                                                        );
                                                      }}
                                                      disabled={
                                                        (currentPages[
                                                          profissional
                                                            .idProfissional
                                                        ] || 1) ===
                                                        Math.ceil(
                                                          profissional.items
                                                            .length /
                                                            itemsPerPage,
                                                        )
                                                      }
                                                      className="px-3 py-1 bg-gray-200 rounded text-sm disabled:opacity-50"
                                                    >
                                                      {"Pr\u00F3xima"}
                                                    </button>
                                                  </div>
                                                )}
                                              </div>
                                            )}
                                          </div>
                                        ))}
                                    </div>
                                  )}
                                </div>
                              ))
                          )}
                        </div>
                      ) : (
                        <p className="text-sm text-gray-500 italic text-center">
                          {"Nenhum receitu\u00E1rio ou laudo encontrado."}
                        </p>
                      )}
                    </>
                  )}
                </>
              )}
            </div>

            {/* NOVA GUIA: Guias SADT Salvas */}
            <div className="bg-white p-4 md:p-6 rounded-2xl shadow-xl border border-gray-100">
              <button
                onClick={() => toggleTab("sadt")}
                className="w-full text-left text-base sm:text-sm font-bold text-green-600 border-b border-gray-200 pb-3 mb-4 flex items-center justify-between"
              >
                <span className="flex items-center gap-2">
                  <FaFileMedicalAlt className="mr-2" /> Guias SADT
                </span>
                <ChevronRight
                  className={`w-4 h-4 transition-transform duration-300 ${
                    activeTab === "sadt" ? "rotate-90" : "rotate-0"
                  }`}
                />
              </button>

              {activeTab === "sadt" && (
                <div className="pt-2">
                  <GuiaSADTSalvas />
                </div>
              )}
            </div>

            <ProntuarioAnexos
              variant="card"
              listMode="cpf"
              prontuarioId={prontuarioAnexosId ?? prontuarioAtualId}
              refreshKey={anexosRefreshKey}
              onUploadSuccess={() => setAnexosRefreshKey((prev) => prev + 1)}
            />

            {/* Outros Profissionais */}
            <div className="bg-white p-4 md:p-6 rounded-2xl shadow-xl border border-gray-100">
              <button
                onClick={() => toggleTab("outros")}
                className="w-full text-left text-base sm:text-sm font-bold text-blue-600 border-b border-gray-200 pb-3 mb-4 flex items-center justify-between"
              >
                <span className="flex items-center gap-2">
                  <FolderOpen className="mr-2" /> {"Outros Prontu\u00E1rios"}
                </span>
                <ChevronRight
                  className={`w-4 h-4 transition-transform duration-300 ${
                    activeTab === "outros" ? "rotate-90" : "rotate-0"
                  }`}
                />
              </button>

              {activeTab === "outros" && (
                <>
                  {loadingOutros ? (
                    <p className="text-sm text-gray-500 italic text-center animate-pulse">
                      Carregando profissionais...
                    </p>
                  ) : (
                    <>
                      {outrosProfissionais.length > 0 ? (
                        renderAtendimentos()
                      ) : (
                        <p className="text-sm text-gray-500 italic text-center">
                          Nenhum atendimento por outros profissionais.
                        </p>
                      )}
                    </>
                  )}
                </>
              )}
              <ToastContainer
                position="top-right"
                autoClose={3000}
                hideProgressBar={false}
                toastClassName={() =>
                  "bg-black text-white font-semibold rounded shadow-md p-3"
                }
                progressClassName="bg-red-500"
              />
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default AtendimentoCompleto;


